import React, { useState, useEffect } from 'react';
import View from 'src/components/view';
import utils from 'src/components/utils';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Element from 'src/components/element';
import Button from '@material-ui/core/Button';

function Consultor() {
  let resetedEndereco = { tipo: 'RESIDENCIAL' };
  let resetedFone = { tipo: 'CELULAR' };
  let resetedEmail = {};
  let data = {
    pessoa: { tipo: 'PF', enderecos: resetedEndereco, telefones: resetedFone, emails: resetedEmail },
    status: { constante: 'PENDENTE' },
    tipo: 'CONSULTOR',
    dadosComerciais: {
      statusPenn: 'ATIVO',
    },
  };

  let [openDialog, setOpenDialog] = useState(false);
  let [openDialogItem, setOpenDialogItem] = useState(false);
  let [view, setView] = useState({});
  let [isSalvando, setIsSalvando] = useState(false);
  let [status, setStatus] = useState({
    dados: false,
    pontos: false,
    carta: false,
    entrevista: false,
    documentos: false,
  });
  let [ready, setReady] = useState(false);
  let [index, setIndex] = useState(0);
  let [distribuidor, setDistribuidor] = useState(0);
  let split = window.location.pathname.substring(1).split('/');
  let [stage, setStage] = useState('list');
  let [tab, setTab] = useState('dados');
  let [crud, setCrud] = useState({ tabConsultor: 'consultores', data: data, changed: data, requireds: {} });
  let [crudItem, setCrudItem] = useState({ data: {}, changed: {}, requireds: {} });
  let user = utils.getUser();
  crud.user = user;
  crud.isSalvando = isSalvando;
  let [isCepValido, setIsCepValido] = useState(false);
  let [requerKitHash, setRequerKitHash] = useState(false);
  let [requerARS, setRequerARS] = useState(false);
  let [requerKitHashOuARS, setRequerKitHashOuARS] = useState(false);
  let [isKitHashObrigatorio, setisKitHashObrigatorio] = useState(true);
  let [isLoteArsObrigatorio, setIsLoteArsObrigatorio] = useState(true);
  let [listaPaisesUsuario, setListaPaisesUsuario] = useState([]);
  let [paisCadastro, setPaisCadastro] = useState(null);
  let [showDlgSelecaoPais, setShowDlgSelecaoPais] = useState(false);
  let [openDialogNovaCidade, setOpenDialogNovaCidade] = useState(false);

  //BRA
  let [listaTipoDoctosEmpresa, setListaTipoDoctosEmpresa] = useState('');
  let [listaTipoDoctosComprovantes, setListaTipoDoctosComprovantes] = useState('');
  let [listaTipoDoctoSocio, setListaTipoDoctoSocio] = useState('');
  let [listaTipoDoctoConjuge, setListaTipoDoctoConjuge] = useState('');

  let [listaOptionsTiposDocumentoEmpresa, setListaOptionsTiposDocumentoEmpresa] = useState([]);
  let [listaOptionsTiposDocumentoSocio, setListaOptionsTiposDocumentoSocio] = useState([]);
  let [listaOptionsTiposDocumentoComprovantes, setListaOptionsTiposDocumentoComprovantes] = useState([]);
  let [listaOptionsTiposDocumentoConjuge, setListaOptionsTiposDocumentoConjuge] = useState([]);

  //MASCARAS
  let [cpfMask, setCpfMask] = useState('999.999.999-99'); // ***.***.999-99
  let [cnpjMask, setCnpjMask] = useState('99.999.999/9999-99'); // **.***.***/9999-99
  let [rgMask, setRgMask] = useState('9999999999'); // *****99999
  let [foneMask, setFoneMask] = useState('99999-99999'); // *****9999
  let [cepMask, setCepMask] = useState('99.999-999'); // 99.999-999
  let voltar = {
    label: utils.lng('voltar', 'Voltar'),
    type: 'button',
    rendered: crud?.data?.id > 0 || crud?.data?.id_consultor > 0,
    background: 'red',
    theme: 'secondary',
    click: {
      validate: false,
      action: 'backTab',
    },
  };

  if (split.length > 1) {
    stage = split[1];
  }

  if (split.length > 2) {
    tab = split[2];
  }

  if (tab === 'recomendar') {
    data.tipo = 'DI';
    data.status = 'RECOMENDACAO';
    data.pessoa.tipo = 'PJ';
    data.dadosComerciais.consultor = stage;
    data.dadosComerciais.statusPenn = 'RECOMENDACAO';
    data.dadosComerciais.kitHash = null;
    data.dadosComerciais.loteArs = null;
    data.dadosComerciais.participouMmn = false;
    data.dadosComerciais.outraMarca = null;
    data.dadosComerciais.possuiParentesco = null;
    data.dadosComerciais.grauParentesco = null;
    data.dadosComerciais.nomeParentesco = null;
    data.dadosComerciais.regimeFiscal = null;
  }

  view.refresh = function () {
    setIndex(index + 1);
  };

  crud.refresh = function () {
    setIndex(index + 1);
    setCrud(crud);
  };

  crud.data.tab = tab;

  const loadTiposDocumentos = function () {
    let codigoPais = paisCadastro && paisCadastro.codigo_pais ? paisCadastro.codigo_pais : utils.getPaisUser();

    const codigoPaisMap = {
      BRA: () => {
        listaTipoDoctosEmpresa = 'list::MEI|CS|REQ_EMPRESARIO';
        listaTipoDoctoSocio = 'list::CNC|CE|RG|RGF|RGV|CPF|CNH|PROC';
        listaTipoDoctosComprovantes =
          'list::COMP_CNPJ|COMP_END_EMP|CONTA_BANCARIA|SINTEGRA|SIMPLES_NACIONAL|COMP_OUTRAS_MARCAS';
        listaTipoDoctoConjuge = 'list::RG|RGF|RGV|CPF|CNH';
      },
      PAR: () => {
        listaTipoDoctosEmpresa = 'list::RUC_PAR|CTC_RUC_PAR|FTC_CT_PAR|ACTA_EMP_PAR|OTROS_DOC_PAR';
        listaTipoDoctoSocio = 'list::CEDULA_PAR|FTC_SER_BAS_PAR|FTC_ID_CON_PAR|FTC_ID_RPE_PAR|FOTO_REC_PAR';
        //listaTipoDoctosComprovantes = 'list::COMP_END_PAR';
        //listaTipoDoctoConjuge = 'list::FICHA_ENTREV_PAR|FICHA_MONITOR_PAR|CEDULA_PAR';
        /*
        setListaTipoDoctosEmpresa('list::RUC_PAR|CTC_RUC_PAR|FTC_CT_PAR|ACTA_EMP_PAR|OTROS_DOC_PAR');
        setListaTipoDoctoSocio('list::CEDULA_PAR|FTC_SER_BAS_PAR|FTC_ID_CON_PAR|FTC_ID_RPE_PAR');
        setListaTipoDoctosComprovantes('list::COMP_END_PAR');
        setListaTipoDoctoConjuge('list::FICHA_ENTREV_PAR|FICHA_MONITOR_PAR|CEDULA_PAR');
        */
      },
      ECU: () => {
        listaTipoDoctosEmpresa = 'list::RUC_ECU|OTROS_DOC_ECU|LGS_CON_ECU|NPRRL_ECU|KARDEX_ACC_ECU';
        listaTipoDoctoSocio = 'list::FTC_CIT_ECU|FTC_SER_ECU|FTC_CIC_ECU|FTC_CIR_ECU|FOTO_REC_ECU';
        //listaTipoDoctosComprovantes = 'list::COMP_END_ECU';
        //listaTipoDoctoConjuge = 'list::FOTO_DI_ECU|RUC_ACTUALIZADO_ECU';
      },
      MEX: () => {
        listaTipoDoctosEmpresa = 'list::CF_MEX|ACTA_EMP_MEX|POD_ADM_MEX|OTROS_DOC_MEX';
        listaTipoDoctoSocio = 'list::FTC_MEX|INE_CONJ_MEX|COM_DOM_MEX|FTC_INR_MEX|FOTO_REC_MEX';
        //listaTipoDoctosComprovantes = 'list::COMP_END_MEX';
        //listaTipoDoctoConjuge = 'list::FTC_MEX|INE_CONJ_MEX';
      },
      BOL: () => {
        listaTipoDoctosEmpresa = 'list::OTROS_DOC_BOL|CCT_BOL|IS_FAT_BOL|RUC_BOL';
        listaTipoDoctoSocio = 'list::CONTRATO_SPV_BOL|CONTRATO_DI_BOL|FICHA_ENTREV_BOL|FICHA_MONITOR_BOL|CEDULA_BOL';
        //listaTipoDoctosComprovantes = 'list::COMP_END_BOL';
        //listaTipoDoctoConjuge = 'list::CONTRATO_SPV_BOL|CONTRATO_DI_BOL|FICHA_ENTREV_BOL|FICHA_MONITOR_BOL|CEDULA_BOL';
      },
      COL: () => {
        listaTipoDoctosEmpresa = 'list::CON_RUT_COL|CRT_CUM_COL|CON_SOC_COL|CRT_EXR_COL|OTROS_DOC_COL';
        listaTipoDoctoSocio = 'list::CED_REP_COL|COM_RES_COL|CED_CIU_COL|FOTO_REC_COL';
      },
      PRT: () => {
        listaTipoDoctosEmpresa = 'list::NIF';
        listaTipoDoctoSocio = 'list::DI|FOTO|ENDERECO';
      },
      USA: () => {
        listaTipoDoctosEmpresa = '** PENDENTE **';
        listaTipoDoctoSocio = '** PENDENTE **';
        //setListaTipoDoctosComprovantes('** PENDENTE **');
        //setListaTipoDoctoConjuge('** PENDENTE **');
      },
    };

    if (codigoPaisMap[codigoPais]) {
      codigoPaisMap[codigoPais]();

      setListaTipoDoctosEmpresa(listaTipoDoctosEmpresa);
      setListaTipoDoctoSocio(listaTipoDoctoSocio);
      setListaTipoDoctosComprovantes(listaTipoDoctosComprovantes);
      setListaTipoDoctoConjuge(listaTipoDoctoConjuge);

      setListaOptionsTiposDocumentoEmpresa([]);
      setListaOptionsTiposDocumentoSocio([]);
      setListaOptionsTiposDocumentoComprovantes([]);
      setListaOptionsTiposDocumentoConjuge([]);

      loadOptionsTiposDocumentos(listaTipoDoctosEmpresa, 'empresa', 'TipoDocumento');
      loadOptionsTiposDocumentos(listaTipoDoctoSocio, 'socio', 'TipoDocumentoPessoa');
      loadOptionsTiposDocumentos(listaTipoDoctosComprovantes, 'comprovante', 'TipoDocumento');
      loadOptionsTiposDocumentos(listaTipoDoctoConjuge, 'conjuge', 'TipoDocumentoPessoa');
    }
  };

  const loadOptionsTiposDocumentos = function (listaConstantes, tipoLista, classeConsultar) {
    let listaOpcoesCampo = [];
    let idPaisCliente = paisCadastro ? (paisCadastro.id ? paisCadastro.id : paisCadastro.id_pais) : null;
    if (idPaisCliente && idPaisCliente != null) {
      let campoFiltro = classeConsultar === 'TipoDocumento' ? 'identificador' : 'constante';
      utils.execute(
        crud,
        classeConsultar + '?pais=' + idPaisCliente + '&' + campoFiltro + '=' + encodeURIComponent(listaConstantes),
        null,
        function (res) {
          if (res.data.length > 0) {
            let listaOpcoes = res.data;

            for (let i = 0; i < listaOpcoes.length; i++) {
              let option = listaOpcoes[i];
              let matchTipoPessoa = true;
              try {
                matchTipoPessoa = !option.tipoPessoa || option.tipoPessoa.constante === crud.data.pessoa.tipo.constante;
              } catch (e) {
                console.error(e);
              }
              if (matchTipoPessoa) {
                option.label = option.descricao;
                option.value = option.id;
                listaOpcoesCampo.push(option);
              }
            }
            if (tipoLista === 'empresa') {
              setListaOptionsTiposDocumentoEmpresa(listaOpcoesCampo);
            } else if (tipoLista === 'socio') {
              setListaOptionsTiposDocumentoSocio(listaOpcoesCampo);
            } else if (tipoLista === 'comprovante') {
              setListaOptionsTiposDocumentoComprovantes(listaOpcoesCampo);
            } else if (tipoLista === 'conjuge') {
              setListaOptionsTiposDocumentoConjuge(listaOpcoesCampo);
            }
            crud.refresh();
            setCrud(crud);
            setIndex(index + 1);
          }
        },
        true,
      );
    }
  };

  const loadMascaras = function () {
    let idPais = paisCadastro && paisCadastro.id_pais ? paisCadastro.id_pais : utils.getIdPaisUser();
    utils.execute(
      crud,
      'FuncaoBasica?pais=' + idPais,
      null,
      function (res) {
        if (res.data.length > 0) {
          let listaFuncoesMascaras = res.data;

          for (let i = 0; i < listaFuncoesMascaras.length; i++) {
            let funcao = listaFuncoesMascaras[i];
            if (funcao.formato) {
              if (funcao.constante.indexOf('CPF') > -1) {
                setCpfMask(funcao.formato);
              } else if (funcao.constante.indexOf('CNPJ') > -1) {
                setCnpjMask(funcao.formato);
              } else if (funcao.constante.indexOf('RG') > -1) {
                setRgMask(funcao.formato);
              } else if (funcao.constante.indexOf('TELEFONE') > -1) {
                setFoneMask(funcao.formato);
              } else if (funcao.constante.indexOf('CEP') > -1) {
                setCepMask(funcao.formato);
              }
            }
          }
          crud.refresh();
          setCrud(crud);
          setIndex(index + 1);
        }
      },
      true,
    );
  };

  const checkUpload = function () {
    if (!crud.data.count_empresa) {
      crud.data.count_empresa = 0;
    }
    if (!crud.data.count_socio) {
      crud.data.count_socio = 0;
    }
    if (!crud.data.count_comprovante) {
      crud.data.count_comprovante = 0;
    }
  };

  const consultarEvolucao = function () {
    utils.execute(
      crud,
      'consultarEvolucaoConsultor?consultor=' + stage,
      null,
      function (res) {
        if (res.data.length > 0) {
          status = res.data[0];

          setStatus(status);
        }

        delete status.fase;

        let dadosBancarios = crud.data?.pessoa?.dadosBancarios;

        if (dadosBancarios) {
          let conta = utils.nvl(dadosBancarios.conta, '');
          let dvConta = utils.nvl(dadosBancarios.dvConta, '');
          let agencia = utils.nvl(dadosBancarios.agencia, '');
          let dvAgencia = utils.nvl(dadosBancarios.dvAgencia, '');

          if (dvConta) dvConta = `-${dvConta}`;
          if (dvAgencia) dvAgencia = `-${dvAgencia}`;

          dadosBancarios.conta_completa = `${conta}${dvConta}`;
          dadosBancarios.agencia_completa = `${agencia}${dvAgencia}`;
        }

        crud.permite_evoluir = true;
        crud.evolucao = {};

        for (const s in status) {
          const sv = status[s];

          if (!sv) {
            crud.permite_evoluir = false;
          }
          crud.evolucao[s] = sv;
        }
        requerKitHash = crud.evolucao.requer_codigo_kit_hash;
        setRequerKitHash(requerKitHash);
        requerARS = crud.evolucao.requer_serial_ars;
        setRequerARS(requerARS);
        requerKitHashOuARS = crud.evolucao.requer_codigo_ars_ou_kit_hash;
        setRequerKitHashOuARS(requerKitHashOuARS);
        crud.refreshObrigatoriedadeKitHashLoteARS();
        refreshTotais();
        crud.refresh();
        setCrud(crud);
        setIndex(index + 1);
      },
      true,
    );

    utils.execute(
      crud,
      'permitirEvoluirEnergy?single=true&id_consultor=' + stage,
      null,
      function (res) {
        crud.permiteEvoluirEnergy = res.data.evoluir_dienergy;

        setIndex(index + 1);
      },
      true,
    );

    if (crud.data) {
      let pais = {
        id: crud.data.id_pais,
        id_pais: crud.data.id_pais,
        codigo: crud.data.codigo_pais,
        codigo_pais: crud.data.codigo_pais,
        nome: crud.data.nome_pais,
        icone: crud.data.icone_pais,
      };
      preenchePaisCadastro(pais);
    }
  };

  const checkPermissaoAcessoDados = function (id_consultor, id_usuario, fnLoadConsultor) {
    utils.execute(
      crud,
      'is_consultor_dentro_rede_usuario?id_consultor=' + id_consultor + '&id_usuario' + id_usuario,
      null,
      function (res) {
        let alow = res.data && res.data[0] ? res.data[0].is_consultor_na_rede : false;
        if (alow) {
          fnLoadConsultor.call();
        } else {
          window.location.href = '/consultores/list';
        }
      },
    );
  };

  const consultarDadosCadastrais = function () {
    utils.execute(crud, 'listarDadosCadastroConsultor?consultor=' + stage, null, function (res) {
      if (res.data[0] != undefined) {
        crud.data.id_pessoa_consultor = res.data[0].id_pessoa;
        crud.data.pessoa.codigo = res.data[0].codigo;
        crud.data.dadosComerciais.outraMarca = res.data[0].outra_marca;
        crud.data.dadosComerciais.participouMmn = res.data[0].participou_mmn;
        crud.data.dadosComerciais.nomeParentesco = res.data[0].nome_parentesco;
        crud.data.dadosComerciais.possuiParentesco = res.data[0].possui_parentesco;
        crud.data.dadosComerciais.grauParentesco = res.data[0].grau_parentesco;
        let pais = {
          id: res.data[0].id_pais,
          id_pais: res.data[0].id_pais,
          codigo: res.data[0].codigo_pais,
          codigo_pais: res.data[0].codigo_pais,
          nome_pais: res.data[0].descricao_pais,
        };
        if (pais && (pais.id > 0 || pais.id_apis > 0)) {
          preenchePaisCadastro(pais);
        }
      }

      refreshTotais();
      crud.refresh();
      setCrud(crud);
      setIndex(index + 1);
    });
  };

  const carregaPaisesOperacaoUsuario = function (openDlgSelecao) {
    paisCadastro = { id_pais: utils.getIdPaisUser(), codigo_pais: utils.getPaisUser() };

    utils.execute(crud, 'listarIdiomas?id_usuario=' + user.id + '&is_cadastro_consultor=true', null, function (res) {
      if (res.data) {
        listaPaisesUsuario = res.data;
        setListaPaisesUsuario(listaPaisesUsuario);
        if (listaPaisesUsuario.length === 1) {
          preenchePaisCadastro(listaPaisesUsuario[0]);
        } else if (openDlgSelecao) {
          crud.switchShowDlgSelecaoPais();
        }
      }
    });
  };

  crud.selecionaPaisCadastro = function (_el, value) {
    preenchePaisCadastro(value.data);
    resetCliente(false);
    crud.switchShowDlgSelecaoPais();
  };

  const preenchePaisCadastro = function (pais) {
    let idPais = pais ? (pais.id && pais.id > 0 ? pais.id : pais.id_pais) : null;
    if (idPais && idPais > 0) {
      paisCadastro = pais;
      setPaisCadastro(paisCadastro);
      utils.loadDicionarioPais(view, paisCadastro.id_pais, () => {
        crud.refresh();
      });
      if (paisCadastro && paisCadastro.id && crud && crud.data && crud.data.pessoa) {
        crud.data.pessoa.id_pais = paisCadastro.id;
      }
      loadTiposDocumentos();
      loadMascaras();
    }
  };

  crud.reiniciaCadastro = function () {
    if (crud.data.id <= 0) {
      crud.add();
    }
  };

  crud.switchShowDlgSelecaoPais = function () {
    let show = !showDlgSelecaoPais;
    showDlgSelecaoPais = show;
    setShowDlgSelecaoPais(showDlgSelecaoPais);
  };

  const dlgSelecaoPais = {
    name: 'dlgSelecaoPais',
    field: 'dlgSelecaoPais',
    type: 'list',
    layout: 'grid',
    size: 10,
    space: 12,
    header: false,
    search: false,
    controls: false,
    add: false,
    edit: true,
    columns: {
      icone: { type: 'img', width: '60px', center: true, cols: 1 },
      nome_pais: { cols: 8, style: { fontSize: '20px' } },
    },
    data: listaPaisesUsuario,
    click: {
      action: 'selecionaPaisCadastro',
    },
  };

  const resetCliente = function (selecionarPais) {
    crud.data = data;
    view.refresh();
    crud.refresh();
    setCrud(crud);
    setIndex(index + 1);
    window.crud = crud;
    utils.execute(
      crud,
      'Cliente/0',
      null,
      function (res) {
        // try {
        //   crud.elements["dadosComerciais.clientePaiEmpresarial"].query = '';
        //   crud.data.dadosComerciais = {clientePaiEmpresarial : null};
        //   crud.data.filial = null;
        //   crud.changed.filial = null;
        //   crud.elements["filial"].query = '';
        //   crud.refresh();
        // } catch (e) {}
        utils.merge(res.data, crud.data);

        crud.data.codigo = crud.data.pessoa.codigo;
        if (user.filialPrincipal) {
          crud.data.filial = user.filialPrincipal.id;
        }
        if (selecionarPais) {
          carregaPaisesOperacaoUsuario(true);
        }
        view.refresh();
        crud.refresh();
        setCrud(crud);
        setIndex(index + 1);
        window.crud = crud;
      },
      true,
    );
  };

  useEffect(() => {
    if (!ready) {
      setReady(true);

      loadTiposDocumentos();
      loadMascaras();
      if ('|list|create|'.indexOf(stage) < 0) {
        const id_consultor = parseInt(stage);

        checkPermissaoAcessoDados(id_consultor, user.id, () => {
          crud.data.aceite_consultor = true;

          if (tab === 'evoluir') {
            utils.execute(
              crud,
              'ClienteDadosComerciais?single=true&target=cliente&lazy=false&resume=true&consultor=' + stage,
              null,
              function (res) {
                if (res.data && res.data.id) {
                  const d = res.data;

                  if (
                    d.status.constante === 'APROVADO' ||
                    d.status.constante === 'EVOLUIR_PARA_DI' ||
                    d.status.constante === 'EVOLUIR_PARA_DIENERGY'
                  ) {
                    crud.permite_evoluir = false;
                  }

                  crud.data.id_consultor = stage;
                  crud.data.tipo = d.dadosComerciais.consultor.tipo.constante;
                  crud.data.aceito = true;
                  crud.distribuidor = d.id;
                  setDistribuidor(d.id);
                }
                consultarEvolucao();
              },
              true,
            );
          } else if (tab === 'recomendar' || tab === 'documentos') {
            utils.execute(
              crud,
              'ClienteDadosComerciais?single=true&target=cliente&lazy=false&resume=true&consultor=' + stage,
              null,
              function (res) {
                if (res.data && res.data.id) {
                  let d = res.data;

                  crud.data = d;
                  crud.distribuidor = d.id;
                  crud.data.aceito = true;
                  crud.data.isConsultorPessoaFisica = d.pessoa?.tipo?.constante === 'PF';
                } else {
                  crud.recomendar = true;
                }
                crud.data.tab = tab;
                crud.data.id_consultor = id_consultor;
                crud.data.documentos = {};

                consultarDadosCadastrais();
                consultarEvolucao();
                checkUpload();
              },
              true,
            );
          } else {
            crud.data.id = id_consultor;
            crud.data.id_consultor = id_consultor;

            utils.execute(
              crud,
              'Cliente/' + stage + '?resume=true',
              null,
              function (res) {
                let c = res.data;

                crud.data = c;
                crud.data.tab = tab;
                crud.data.id_consultor = id_consultor;

                if (c.usuario) {
                  let dono = c.usuario;

                  if (dono.id !== user.id) {
                    crud.data.editar = false;
                  }
                }
                carregaPaisesOperacaoUsuario(false);
                preenchePaisCadastro({
                  id_pais: c.id_pais,
                  nome_pais: c.nome_pais,
                  codigo_pais: c.codigo_pais,
                  icone: c.icone_pais,
                });
                consultarEvolucao();
              },
              true,
            );
          }
        });
      } else if ('|create|'.indexOf(stage) >= 0) {
        loadCfgRegraAdesaoInicial();
        resetCliente(true);
      }
    }
  });

  crud.setarCEP = function (args) {
    setIsCepValido(args.data && args.data.cidade ? true : false);
    try {
      crud.data.pessoa.enderecos.cidade = args.data.cidade;
    } catch (e) {
      console.error(e);
    }
  };

  crud.trataValidacaoCNPJ = function (args) {
    try {
      if (args.data.jaExiste === true) {
        crud.data.pessoa.pessoaJuridica.cnpj = null;
        crud.exibeAlerta(args.data.mensagem);
      }
    } catch (e) {
      console.error(e);
    }
  };

  crud.trataValidacaoEmail = function (args) {
    try {
      if (args.data.jaExiste === true) {
        crud.data.pessoa.emails.email = null;
        crud.exibeAlerta(args.data.mensagem);
      }
    } catch (e) {
      console.error(e);
    }
  };

  crud.trataValidacaoTelefone = function (args) {
    try {
      if (args.data.jaExiste === true) {
        crud.data.pessoa.telefones.ddi = null;
        crud.data.pessoa.telefones.ddd = null;
        crud.data.pessoa.telefones.telefone = null;
        crud.exibeAlerta(args.data.mensagem);
      }
    } catch (e) {
      console.error(e);
    }
  };

  crud.exibeAlerta = function (msg) {
    let actions = [];
    actions.push({ label: utils.lng('confirmar', 'Confirmar'), action: () => { } });
    if (window.dialog) {
      window.dialog.alert(msg, null, actions);
    }
  };

  crud.add = function (el, args) {
    window.location.href = '/consultores/create';
  };

  crud.openDialogEscolha = function (el, args) {
    if (crud.data.id > 0 && crud.data.status && crud.data.status.constante === 'PENDENTE') {
      let actions = [];
      actions.push({ label: utils.lng('confirmar', 'Confirmar'), action: () => { } });

      if (window.dialog) {
        window.dialog.alert(
          utils.lng(
            'consultor_pendente_orientar_aceite_email',
            'Esse consultor consta como pendente, oriente-o a realizar o aceite através do e-mail informado no momento do cadastro',
          ),
          null,
          actions,
        );
      }
    } else {
      setOpenDialog(true);
    }
  };

  crud.onUploadEmpresa = function () {
    checkUpload();
    crud.data.count_empresa = crud.data.count_empresa + 1;
    crud.onUpload();
  };

  crud.onUploadSocio = function () {
    checkUpload();
    crud.data.count_socio = crud.data.count_socio + 1;
    crud.onUpload();
  };

  crud.onUploadComprovante = function () {
    checkUpload();
    crud.data.count_comprovante = crud.data.count_comprovante + 1;
    crud.onUpload();
  };

  crud.onUploadConjuge = function () {
    checkUpload();
    crud.data.count_conjuge = crud.data.count_conjuge + 1;
    crud.onUpload();
  };

  crud.onUpload = function () {
    crud.data.tipo_doc_comprovante = null;
    crud.data.tipo_doc_empresa = null;
    crud.data.tipo_doc_socio = null;
    crud.data.tipo_doc_conjuge = null;

    crud.refresh();
  };

  crud.editarItem = function (_el, args) {
    crudItem.data.id = args.data.id_vinculo;
    crudItem.changed.id = args.data.id_vinculo;
    crudItem.data.quantidade = args.data.quantidade;
    crudItem.changed.quantidade = args.data.quantidade;

    setOpenDialogItem(true);
  };

  const refreshTotais = function () {
    if (window.wProdutos) {
      window.wProdutos.search();
    }
    if (window.wRegras) {
      window.wRegras.search();
    }
  };

  crud.refreshTotais = refreshTotais;

  const handleCloseDialog = function () {
    setProdutosSelecionados({});
    msgResultadoVinculacao = '';
    window.location.reload();
  };

  const handleCloseDialogItem = function () {
    setOpenDialogItem(false);
  };

  const confirmarEdicaoItem = function () {
    if (crudItem.data.quantidade > 0) {
      const _ks_ = {};

      _ks_.crud = crudItem;
      _ks_.changed = crudItem.data;
      _ks_.element = {};

      _ks_.complete = function (res) {
        if (window.wProdutos) {
          window.wProdutos.search();
        }

        if (window.wRegras) {
          window.wRegras.search();
        }
        consultarEvolucao();
      };

      _ks_.cfg = {
        url: 'VendaVinculo/' + crudItem.data.id,
        method: 'PUT',
      };
      utils.call(_ks_);
      setOpenDialogItem(false);
    }
  };

  crud.setarTab = function (_el, args) {
    let key = args.data.key;

    if (stage != 'create') {
      window.location.href = '/consultores/' + stage + '/' + key;
      localStorage.setItem('lastTab', key);
    }
  };

  crud.setarTabConsultor = function (_el, args) {
    let key = args.data.key;

    crud.tabConsultor = key;

    crud.refresh();
  };

  crud.changeCpf = function (el, args) {
    let cpf = el.query;
    cpf = utils.onlyNumber(cpf, false);
    let docLength = getLengthDocumentoPais(utils.getPaisUser());
    if (cpf && cpf.length >= docLength) {
      crud.validaIsPessoaSocioOuConjuge(cpf);
    }
  };

  const getLengthDocumentoPais = function (codigoPais) {
    let docLength = 11;
    if (utils.getPaisUser() === 'BRA') {
      docLength = 11;
    } else if (utils.getPaisUser() === 'ECU') {
      docLength = 13;
    } else if (utils.getPaisUser() === 'MEX') {
      docLength = 12;
    } else if (utils.getPaisUser() === 'PAR') {
      docLength = 8;
    }
    return parseInt(docLength);
  };

  crud.validaIsPessoaSocioOuConjuge = function (cpfPessoa) {
    if (cpfPessoa) {
      utils.execute(
        crud,
        'validaExistenciaSocioOuConjuge?documento=' + cpfPessoa,
        null,
        function (res) {
          if (res.data && (res.data.hasSocio === true || res.data.hasConjuge === true)) {
            let msgSocio = utils.lng(
              'cpf_ja_cadastrado_como_socio_impossivel_prosseguir',
              'O CPF informado no registro de consultor já existe em nossa base como sócio! Não será possível prosseguir!',
            );
            let msgConjuge = utils.lng(
              'cpf_ja_cadastrado_como_conjuge_impossivel_prosseguir',
              'O CPF informado no registro de consultor já existe em nossa base como cônjuge! Não será possível prosseguir!',
            );

            let msg = res.data.hasSocio ? msgSocio : msgConjuge;
            utils.prompt(
              { prompt: msg },
              () => { },
              () => { },
            );
            crud.data.pessoa.pessoaFisica.cpf = '';
            crud.data.pessoa = { tipo: 'PF', enderecos: resetedEndereco, telefones: resetedFone, emails: resetedEmail };
            setIndex(index + 1);
          } else {
            crud.validaExistenciaPessoaPorCPF(cpfPessoa);
          }
        },
        true,
      );
    }
  };

  crud.validaExistenciaPessoaPorCPF = function (cpf) {
    utils.execute(
      crud,
      'consultarCPF?cpf=' + cpf + '&filtrar_pais=' + true,
      null,
      function (res) {
        if (res.data.id) {
          utils.prompt(
            {
              prompt: utils.lng(
                'indentificamos_cadastro_com_cpf_deseja_continuar',
                'Identificamos um cadastro já iniciado com o CPF informado, caso queira que os dados sejam pré-carregados clique no botão confirmar',
              ),
            },
            function () {
              let person = res.data;
              if (person) {
                person = crud.carregaPessoaFormulario(person);
                person.novoCodMundial = true;
                crud.data.pessoa = person;
                crud.validaClientePessoa(crud.data.pessoa);
              }
              setIndex(index + 1);
            },
            function () {
              crud.data.pessoa.pessoaFisica.cpf = '';
              setIndex(index + 1);
            },
          );
        }
      },
      true,
    );
  };

  crud.carregaPessoaFormulario = function (newPessoa) {
    let pessoaRetorno = newPessoa;
    pessoaRetorno.enderecos =
      pessoaRetorno.enderecos && pessoaRetorno.enderecos[0] ? pessoaRetorno.enderecos[0] : resetedEndereco;
    pessoaRetorno.telefones =
      pessoaRetorno.telefones && pessoaRetorno.telefones[0] ? pessoaRetorno.telefones[0] : resetedFone;
    pessoaRetorno.emails = pessoaRetorno.emails && pessoaRetorno.emails[0] ? pessoaRetorno.emails[0] : resetedEmail;
    if (pessoaRetorno.enderecos) {
      setIsCepValido(
        pessoaRetorno.enderecos.cep &&
        pessoaRetorno.enderecos.cep.length === 8 &&
        pessoaRetorno.enderecos.cidade &&
        pessoaRetorno.enderecos.id,
      );
    }
    return pessoaRetorno;
  };

  crud.validaClientePessoa = function (pessoaCarregada) {
    if (pessoaCarregada && pessoaCarregada.id) {
      utils.execute(
        crud,
        'v1/consulta_cliente_por_pessoa?id_pessoa=' + pessoaCarregada.id,
        null,
        function (res) {
          if (res.data && res.data.pessoa && res.data.pessoa.id === pessoaCarregada.id) {
            utils.prompt(
              {
                prompt: utils.lng(
                  'ja_existe_cliente_pessoa',
                  'Já existe um Cliente relacionado à esta pessoa! Não será possível prosseguir!',
                ),
              },
              () => { },
              () => { },
            );
            crud.data.pessoa.pessoaFisica.cpf = '';
            crud.data.pessoa = { tipo: 'PF', enderecos: resetedEndereco, telefones: resetedFone, emails: resetedEmail };
            setIndex(index + 1);
          }
        },
        true,
      );
    }
  };

  crud.changeParticipaMmn = function () {
    if (crud.data.dadosComerciais.participaMmn !== false) {
      crud.data.dadosComerciais.chaveKitHash = null;
      crud.data.dadosComerciais.kitHash = null;
      crud.data.dadosComerciais.loteArs = null;
    }
  };

  const loadCfgRegraAdesaoInicial = function () {
    utils.execute(
      crud,
      'consulta_regra_adesao_inicial_consultor?id_usuario=' +
      user.id +
      '&id_consultor' +
      (crud.data ? crud.data.id : 0),
      null,
      function (res) {
        if (res.data && res.data.length > 0) {
          let regraAdesao = res.data[0];

          requerKitHash = regraAdesao.requer_codigo_kit_hash;
          setRequerKitHash(requerKitHash);
          requerARS = regraAdesao.requer_serial_ars;
          setRequerARS(requerARS);
          requerKitHashOuARS = regraAdesao.requer_codigo_ars_ou_kit_hash;
          setRequerKitHashOuARS(requerKitHashOuARS);
          crud.refreshObrigatoriedadeKitHashLoteARS();
        }
      },
      true,
    );
  };

  crud.refreshObrigatoriedadeKitHashLoteARS = function () {
    isKitHashObrigatorio =
      user.codigo_pais === 'BRA' &&
      (requerKitHash === true ||
        requerKitHashOuARS === true ||
        (!crud.data.dadosComerciais?.chaveKitHash && !crud.data.dadosComerciais.loteArs)) &&
      crud.data.dadosComerciais.participouMmn !== true;
    setisKitHashObrigatorio(isKitHashObrigatorio);
    isLoteArsObrigatorio =
      user.codigo_pais === 'BRA' &&
      (requerARS === true ||
        (requerKitHashOuARS === true && (!crud.data.dadosComerciais || !crud.data.dadosComerciais.chaveKitHash))) &&
      crud.data.dadosComerciais.participouMmn !== true;
    setIsLoteArsObrigatorio(isLoteArsObrigatorio);
  };

  crud.salvarCliente = function () {
    if (isSalvando) return;

    const _ks_validate = {};

    crud.data.customMessageCreate = 'create.consultor.success';

    _ks_validate.crud = crud;
    _ks_validate.validate = true;
    _ks_validate.changed = crud.data;
    _ks_validate.element = {};

    setIsSalvando(true);

    _ks_validate.cfg = {
      url: 'Cliente/' + (crud.data.id ? crud.data.id : '0') + '/validate',
      method: 'POST',
      alert: false,
      complete: () => setIsSalvando(false),
      onerror: () => setIsSalvando(false),
    };
    _ks_validate.complete = function (res) {
      if (res.data.validate) {
        if (
          crud &&
          crud.data &&
          crud.data.pessoa &&
          crud.data.pessoa.codigo &&
          crud.data.pessoa.codigo != null &&
          crud.data.pessoa.codigo !== ''
        ) {
          crud.gravarPessoaAndCliente();
        } else {
          crud.buscaCodigoMundial();
        }
      }
    };
    utils.call(_ks_validate);
  };

  crud.buscaCodigoMundial = function () {
    if (!crud.data.filial) {
      utils.prompt(
        { prompt: utils.lng('filial_obrigatoria', 'A Filial é obrigatória. Verifique!') },
        () => { },
        () => { },
      );
    } else {
      const _ks_busca_cod_mun_ = {};

      _ks_busca_cod_mun_.crud = crud;
      _ks_busca_cod_mun_.validate = false;
      //_ks_busca_cod_mun_.changed = crud.data;
      _ks_busca_cod_mun_.element = {};

      _ks_busca_cod_mun_.cfg = {
        url: '/codigo_mundial/novo?id_filial=' + crud.data.filial.id,
        method: 'GET',
        alert: false,
      };
      _ks_busca_cod_mun_.complete = function (res) {
        if (res.data) {
          crud.data.pessoa.codigo = res.data;
          crud.gravarPessoaAndCliente();
        } else {
          utils.prompt(
            {
              prompt: utils.lng(
                'falha_gerar_codigo_mundial',
                'Ocorreu uma falha ao tentar gerar um novo Código Mundial, entre em contato com o suporte!',
              ),
            },
            () => { },
            () => { },
          );
        }
      };
      utils.call(_ks_busca_cod_mun_);
    }
  };

  crud.gravarPessoaAndCliente = function () {
    if (crud.data && crud.data.pessoa) {
      if (!crud.data.pessoa.nomeReduz) {
        crud.data.pessoa.nomeReduz = crud.data.pessoa.nome;
      }
      const _ks_pessoa = {};

      _ks_pessoa.crud = crud;
      _ks_pessoa.validate = true;
      _ks_pessoa.changed = crud.data.pessoa;
      _ks_pessoa.element = {};

      _ks_pessoa.cfg = {
        url: 'Pessoa' + (crud.data.pessoa.id ? '/' + crud.data.pessoa.id : ''),
        method: crud.data.pessoa.id ? 'PUT' : 'POST',
        alert: false,
      };
      _ks_pessoa.complete = function (res) {
        if (res && !res.error && res.data && res.data.id && crud.data) {
          crud.data.pessoa = crud.carregaPessoaFormulario(res.data);
          const _ks_cliente = {};

          _ks_cliente.crud = crud;
          _ks_cliente.validate = true;
          _ks_cliente.changed = crud.data;
          _ks_cliente.element = {};

          let metodo = crud.data.id ? 'PUT' : 'POST';
          _ks_cliente.cfg = {
            url: 'Cliente' + (crud.data.id ? '/' + crud.data.id : ''),
            method: metodo,
            params: {
              customMessageCreate:
                metodo === 'PUT'
                ? utils.lng(
                    'msg.edicao.consultor',
                    'Dados salvos com sucesso! Envie os documentos necessários, por favor.',
                  )
                : utils.lng(
                    'msg.cadastro.consultor',
                    'Consultor registrado com sucesso! Siga o Fluxo para promovê-lo a distribuidor ou acesse a área Meus Consultores.'
                  )+(' CM: '+(crud?.data?.pessoa?.codigo || ''))
            }
          };
          _ks_cliente.complete = crud.afterSaveCliente;
          utils.call(_ks_cliente);
        }
      };
      utils.call(_ks_pessoa);
    }
  };

  let [somaPontosProdutosSelecionados, setSomaPontosProdutosSelecionados] = useState(0);
  let [produtosSelecionados, setProdutosSelecionados] = useState({});
  let msgResultadoVinculacao = '';

  const checkAll = function (allChecked, listaItens) {
    if (listaItens && listaItens != null && listaItens.length > 0) {
      view.loadingStart();
      let item = null;
      for (let i = 0; i < listaItens.length; i++) {
        item = listaItens[i];
        item.selecionado = allChecked;
        manageSelecaoProdutos(item, false);
        if (i === listaItens.length - 1) {
          view.loadingEnd();
        }
      }
    }
    refreshSomaPontos();
  };

  crud.selecionaProduto = function (_el, args) {
    let item = args.data;
    if (item) {
      setTimeout(() => manageSelecaoProdutos(item), 700);
    }
  };

  crud.setQuantidadeSelecionada = function (el, item, xxx, yyy) {
    refreshSomaPontos();
  };

  const manageSelecaoProdutos = function (item, refreshPontos = true) {
    let check = item.selecionado;
    if (check === true) {
      addItem(item, refreshPontos);
    } else {
      removeItem(item, refreshPontos);
    }
  };

  const addItem = function (item, refreshPontos) {
    if (!produtosSelecionados[item.id_item]) {
      produtosSelecionados[item.id_item] = item;
      if (refreshPontos) {
        refreshSomaPontos();
      }
    }
  };

  const removeItem = function (item, refreshPontos) {
    if (produtosSelecionados[item.id_item]) {
      delete produtosSelecionados[item.id_item];
      if (refreshPontos) {
        refreshSomaPontos();
      }
    }
  };

  const refreshSomaPontos = function () {
    let pts = 0.0;
    for (const id_item in produtosSelecionados) {
      let item = produtosSelecionados[id_item];
      if (item && item.selecionado && item.qtde_selecionada > 0 && item.qtde_selecionada <= item.quantidade) {
        pts += getPontosSelecionados(item);
      }
    }
    setSomaPontosProdutosSelecionados(utils.number(pts, 4));
  };

  const getPontosSelecionados = function (item) {
    return (item.qtde_selecionada / item.quantidade) * item.pontos_item;
  };

  const confirmaVinculacaoProdutos = function () {
    let hasItensVincular =
      produtosSelecionados && produtosSelecionados != null && Object.entries(produtosSelecionados)[0];
    if (hasItensVincular) {
      let first = Object.entries(produtosSelecionados)[0][1];
      if (first) {
        view.loadingStart();
        sendItemVinculo(first, 0);
      }
    } else {
      let actions = [];
      actions.push({ label: utils.lng('confirmar', 'Confirmar'), action: () => { } });

      if (window.dialog) {
        window.dialog.alert(utils.lng('nenhum_item_selecionado', 'Nenhum Ítem selecionado'), null, actions);
      }
    }
  };

  //envia os itens para víncular um por um, para aproveitar o POST e observer
  const sendItemVinculo = function (itemVinculo, index) {
    if (itemVinculo && itemVinculo.qtde_selecionada > 0 && itemVinculo.qtde_selecionada <= itemVinculo.quantidade) {
      let request = getNewRequest();
      let newVendaVinculo = getVendaVinculoData(itemVinculo);

      request.body = newVendaVinculo;

      request.complete = function (res) {
        msgResultadoVinculacao +=
          '<br><b>' + itemVinculo.codigo_produto + '</b> - ' + itemVinculo.descricao + ': ' + res.message;

        let nextIndex = index + 1;
        let nextItem = Object.entries(produtosSelecionados)[nextIndex];
        if (nextItem) {
          sendItemVinculo(nextItem[1], nextIndex);
        } else {
          finalizaVinculacao();
        }
      };

      utils.call(request);
    } else {
      finalizaVinculacao();
    }
  };

  const finalizaVinculacao = function () {
    view.loadingEnd();
    const actions = [];
    const finishFunction = () => {
      setProdutosSelecionados({});
      msgResultadoVinculacao = '';
      handleCloseDialog();
    };

    actions.push({ label: utils.lng('confirmar', 'Confirmar'), action: finishFunction });

    if (window.dialog) {
      window.dialog.alert(
        utils.lng('resultado_vinculacao', 'Resultado Vinculação') + '<br>' + msgResultadoVinculacao,
        null,
        actions,
      );
    } else {
      finishFunction.call();
    }
  };

  const getNewRequest = function () {
    const req = {};
    req.crud = crud;
    req.cfg = {
      url: 'VendaVinculo',
      alert: false,
      method: 'POST',
    };
    return req;
  };

  const getVendaVinculoData = function (item) {
    let newVendaVinculo = {};
    newVendaVinculo['hubPedVendaItem'] = item.id_item;
    newVendaVinculo['consultor'] = crud.data.id;
    newVendaVinculo['quantidade'] = item.qtde_selecionada;
    newVendaVinculo['pontos'] = getPontosSelecionados(item);
    newVendaVinculo['usuario'] = utils.getUser().id;
    return newVendaVinculo;
  };

  const escolhaProdutos = {
    name: 'escolhaProdutos',
    clientId: 'escolhaProdutos',
    type: 'list',
    layout: 'table',
    search: true,
    controls: false,
    size: 500,
    add: false,
    // widgetVar: 'produtoSelecionado',
    // itemVar: 'produtoSelecionado',
    readOnly: false,
    rowEdit: false,
    checkAllFunction: checkAll,
    columns: {
      selecionado: {
        type: 'checkbox',
        field: 'selecionado',
        required: false,
        nullValues: false,
        readOnly: false,
        isRefreshParent: false,
        space: 1,
        click: {
          action: 'selecionaProduto',
          closeDialog: false,
        },
      },
      avatar: { type: 'avatar' },
      codigo_produto: { label: utils.lng('codigo', 'Código') },
      numero: { label: utils.lng('pedido', 'Pedido') },
      data_pedido: { label: 'Data', type: 'datetime' },
      descricao: { label: utils.lng('descricao', 'Descrição') },
      quantidade: { label: utils.lng('quantidade', 'Quantidade') },
      qtde_selecionada: {
        label: utils.lng('quantidade_selecionada', 'Qtde. Selecionada'),
        rowEdit: true,
        type: 'spinner2',
        disableOnLimit: true,
        min: 1,
        max: '${@this.quantidade}',
        // disabled: "${!(@this.selecionado == true)}",
        numeric: true,
        sort: false,
        change: {
          action: 'setQuantidadeSelecionada',
        },
      },
    },
    list: {
      url: 'listarEscolhaPontosConsultor',
      params: {
        id_consultor: '${crud.data.id_consultor}',
      },
    },
  };

  const frmEditItem = {
    name: 'frmEditItem',
    elements: {
      quantidade: { type: 'number', label: utils.lng('quantidade', 'Quantidade'), required: true },
    },
  };

  const consultores = {
    elements: {
      tabs: {
        type: 'list',
        layout: 'tab-menu',
        name: 'nav-consultores',
        search: false,
        controls: false,
        itemVar: 'ti',
        rowStyleClass: '${ti.key === crud.tabConsultor ? "ui-tab-menu-sel" : ""}',
        header: false,
        columns: {
          label: { type: 'span' },
        },
        click: {
          action: 'setarTabConsultor',
        },
        data: [
          { label: utils.lng('consultores_upper', 'CONSULTORES'), key: 'consultores' },
          { label: utils.lng('di', 'D.I.'), key: 'distribuidores' },
          // { label: utils.lng("di_energy_upper", "DI ENERGY"), key: "consultores_energy" },
          // { label: utils.lng("di_nipponflex_upper", "DI NIPPONFLEX"), key: "distribuidores" },
        ],
      },
      content: {
        styleClass: 'ui-lista-consultores',
        elements: {
          tb_a: {
            rendered: "${crud.tabConsultor  === 'consultores'}",
            header: false,
            layout: 'clear',
            add: true,
            print: false,
            type: 'list',
            list: {
              url: 'listarMeusConsultores',
              send: {
                query: '${@this.query}',
              },
            },
            click: {
              action: 'open',
            },
            columns: {
              card: {
                type: 'card',
                elements: {
                  avatar: { field: 'avatar', styleClass: 'noppading' },
                  detalhes: {
                    style: { fontSize: '13px' },
                    type: 'span',
                    field: 'detail',
                    elements: {
                      nome: {
                        field: 'nomes',
                        value: '${@this.codigo + " - " + @this.nome}',
                        style: { fontSize: '14px' },
                      },
                      nome_pai: {
                        field: 'nome_pai',
                        value: utils.lng('nome_pai_label_e_nome', '<b>PAI:</b> ${@this.nome_pai}'),
                      },
                      cidade: {
                        field: 'cidade_uf',
                        value: utils.lng('cidade_uf_label_e_cidade', '<b>CIDADE:</b> ${@this.cidade_uf}'),
                      },
                      tipo_cliente: {
                        field: 'tipo_cliente',
                        value: utils.lng('tipo_cliente_label_e_tipo', '<b>TIPO:</b> ${@this.tipo_cliente}'),
                      },
                      data_adm: {
                        field: 'data_adm',
                        value: utils.lng('data_adm_label_e_data', '<b>DATA DE ADMISSÃO:</b> ${@this.data_admissao}'),
                      },
                    },
                  },
                  remove: {
                    type: 'button',
                    rendered: false,
                    icon: 'fa fa-trash',
                    click: { url: 'Cliente/{id}', method: 'DELETE' },
                  },
                },
              },
            },
          },
          tb_b: {
            layout: 'clear',
            rendered: "${crud.tabConsultor  === 'distribuidores'}",
            header: false,
            add: false,
            print: false,
            type: 'list',
            list: {
              url: 'listarMeusDistribuidores',
              send: {
                query: '${@this.query}',
              },
            },
            columns: {
              card: {
                type: 'card',
                elements: {
                  avatar: { field: 'avatar', styleClass: 'noppading' },
                  detalhes: {
                    style: { fontSize: '13px' },
                    type: 'span',
                    field: 'detail',
                    elements: {
                      nome: { field: 'nomes', value: '${@this.codigo + " - " + @this.nome}' },
                      nome_pai: {
                        field: 'nome_pai',
                        value: utils.lng('nome_pai_label_e_nome', '<b>PAI:</b> ${@this.nome_pai}'),
                      },
                      tipo_cliente: {
                        field: 'tipo_cliente',
                        value: '<b>' + utils.lng('tipo', 'tipo').toUpperCase() + ':</b> ' + '${@this.tipo_descricao}',
                      },
                      data_admissao: {
                        field: 'data_admissao',
                        value: utils.lng('data_adm_label_e_data', '<b>DATA DE ADMISSÃO:</b> ${@this.data_admissao}'),
                      },
                      filial_abrev: {
                        field: 'filial_abrev',
                        value: '<b>' + utils.lng('filial', 'filial').toUpperCase() + ':</b> ' + '${@this.filial_abrev}',
                      },
                      status_descricao: { field: 'status_descricao', style: { textAlign: 'right' } },
                    },
                  },
                  remove: {
                    type: 'button',
                    rendered: false,
                    icon: 'fa fa-trash',
                    click: { url: 'Cliente/{id}', method: 'DELETE' },
                  },
                },
              },
            },
          },
          // tb_e: {
          //   rendered: "${crud.tabConsultor  === 'consultores_energy'}",
          //   header: false,
          //   layout: "clear",
          //   add: false,
          //   type: "list",
          //   list: {
          //     url: "listarMeusConsultoresEnergy",
          //     send: {
          //       query: "${@this.query}",
          //     },
          //   },
          //   click: {
          //     action: "open",
          //   },
          //   columns: {
          //     card: {
          //       type: "card",
          //       elements: {
          //         avatar: { field: "avatar", styleClass: "noppading" },
          //         detalhes: {
          //           style: { fontSize: "13px" },
          //           type: "span",
          //           field: "detail",
          //           elements: {
          //             nome: { field: "nomes", value: '${@this.codigo + " - " + @this.nome}', style: { fontSize: "14px" } },
          //             nome_pai: { field: "nome_pai", value: utils.lng("nome_pai_label_e_nome", "<b>PAI:</b> ${@this.nome_pai}") },
          //             cidade: { field: "cidade_uf", value: utils.lng("cidade_uf_label_e_cidade", "<b>CIDADE:</b> ${@this.cidade_uf}") },
          //             tipo_cliente: { field: "tipo_cliente", value: utils.lng("tipo_cliente_label_e_tipo", "<b>TIPO:</b> ${@this.tipo_cliente}") },
          //             data_adm: { field: "data_adm", value: utils.lng("data_adm_label_e_data", "<b>DATA DE ADMISSÃO:</b> ${@this.data_admissao}") },
          //           },
          //         },
          //         remove: { type: "button", rendered: false, icon: "fa fa-trash", click: { url: "Cliente/{id}", method: "DELETE" } },
          //       },
          //     },
          //   },
          // },
        },
      },
    },
  };

  const getIdPaisAtual = () => {
    const idPais = utils.getIdPaisUser();

    if (!paisCadastro) return idPais;

    return utils.nvl(paisCadastro.id_pais, paisCadastro.id, idPais);
  };

  const uploadCfg = {
    appendColumns: ({ item }) => {
      if (item?.tipo?.label) return <td>{item.tipo.label}</td>;
      return <></>;
    },
  };

  const getByPath = (obj, path) => {
    if (!obj || !path) return undefined;

    return path.split('.').reduce((acc, part) => {
      if (acc == null) return undefined;
      return acc[part];
    }, obj);
  };

  const getDocTipoId = (docTipo, index) => {
    return utils.nvl(docTipo?.id, docTipo?.value, docTipo?.constante, `idx_${index}`);
  };

  const getDocStorageKey = (grupo, docTipo, index) => {
    return `${grupo}_${getDocTipoId(docTipo, index)}`;
  };

  const getDocFieldPath = (grupo, docTipo, index) => {
    return `documentosPorTipo.${getDocStorageKey(grupo, docTipo, index)}`;
  };

  const ensureDocumentosPorTipo = () => {
    crud.data.documentosPorTipo = crud.data.documentosPorTipo || {};
    crud.changed.documentosPorTipo = crud.changed.documentosPorTipo || {};
  };

  const getDocFiles = (grupo, docTipo, index) => {
    ensureDocumentosPorTipo();

    const field = getDocFieldPath(grupo, docTipo, index);
    const files = getByPath(crud?.data, field);

    if (!files) return [];
    return Array.isArray(files) ? files : [files];
  };

  /**
   *
   * Remove acentos e deixa em minusculo para comparar
   */
  const normalizarLabelDocumento = (label = '') => {
    return String(label)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  };

  /**
   *
   * Retorna se o documento pertence ao grupo de documentos fiscais alternativos ou pessoais alternativos
   */
  const getGrupoDocumentoAlternativo = (docTipo) => {
    const label = normalizarLabelDocumento(docTipo?.label);
    if (!label) return null;

    const documentosPessoaisAltKeyword = ['rg', 'cpf', 'cnh'];
    const documentosFiscaisAltKeyword = [
      'certificado de micro empresa(mei)',
      'contrato social',
      'requerimento de empresario',
    ];

    if (
      documentosPessoaisAltKeyword.some((keyword) => label == keyword) ||
      documentosPessoaisAltKeyword.some((keyword) => label == keyword + '*')
    ) {
      return 'documentos_pessoais_alt';
    }

    if (
      documentosFiscaisAltKeyword.some((keyword) => label == keyword) ||
      documentosFiscaisAltKeyword.some((keyword) => label == keyword + '*')
    ) {
      return 'documentos_fiscais_alt';
    }

    return null;
  };

  const isDocObrigatorio = (docTipo, grupo, index) => {
    // Regra específica para o comprovante de participação em MMN, que só é obrigatório se o consultor participar de MMN
    if (docTipo.label.includes('Comprovante participação - Outras marcas')) {
      return crud.data.dadosComerciais?.participaMmn === true;
    }

    // Se não tiver label ou a label não terminar com *, não é obrigatório
    if (!docTipo?.label || !docTipo.label.trimEnd().endsWith('*')) return false;

    // Se for um documento alternativo, define como opcional.
    const grupoAlternativo = getGrupoDocumentoAlternativo(docTipo);
    if (grupoAlternativo) return false;

    return true;
  };

  const getNomeArquivoAnexado = (grupo, docTipo, index) => {
    const files = getDocFiles(grupo, docTipo, index);
    if (!files.length) return '';

    const file = files[0];
    return utils.nvl(file?.name, file?.nome, file?.label, utils.lng('arquivo_anexado', 'Arquivo anexado'));
  };

  const toDocumentoArray = (value) => {
    if (!value) return [];
    return Array.isArray(value) ? value : [value];
  };

  const podeEditarDocumentos = () => {
    return Boolean(
      crud?.evolucao?.permite_alterar_consultor &&
      crud?.evolucao?.pontos_atingidos &&
      crud?.evolucao?.carta &&
      !crud?.evolucao?.is_consultor_evoluindo,
    );
  };

  const getLabelGrupoDocumento = (grupo) => {
    if (grupo === 'empresa') return utils.lng('documentos_fiscais', 'Documentos fiscais');
    if (grupo === 'comprovante') return utils.lng('comprovantes', 'Comprovantes');
    if (grupo === 'socio') return utils.lng('documentos_pessoais', 'Documentos pessoais');
    if (grupo === 'conjuge') return utils.lng('documentos_conjuge', 'Documentos do cônjuge');
    return grupo;
  };

  const getOptionItemsComAlternativos = (options = []) => {
    let optionItems = toDocumentoArray(options).map((docTipo, index) => ({ docTipo, index }));

    const documentosPessoaisAlt = optionItems.filter(
      ({ docTipo }) => getGrupoDocumentoAlternativo(docTipo) === 'documentos_pessoais_alt',
    );

    const documentosFiscaisAlt = optionItems.filter(
      ({ docTipo }) => getGrupoDocumentoAlternativo(docTipo) === 'documentos_fiscais_alt',
    );

    optionItems = optionItems.filter(
      ({ docTipo }) =>
        !getGrupoDocumentoAlternativo(docTipo) ||
        (getGrupoDocumentoAlternativo(docTipo) !== 'documentos_pessoais_alt' &&
          getGrupoDocumentoAlternativo(docTipo) !== 'documentos_fiscais_alt'),
    );

    if (documentosPessoaisAlt.length > 0) {
      optionItems.push({
        docTipo: {
          label: 'Documentos pessoais (RG, CNH, CPF)*',
          nome: 'documentos_pessoais_alternativos',
          constante: 'documentos_pessoais_alternativos',
          descricao: 'Documentos pessoais (RG, CNH, CPF)*',
        },
        groupedAlternatives: documentosPessoaisAlt,
      });
    }

    if (documentosFiscaisAlt.length > 0) {
      optionItems.push({
        docTipo: {
          label: 'Documentos fiscais (Certificado MEI, Contrato Social, Requerimento de Empresário)*',
          nome: 'documentos_fiscais_alternativos',
          constante: 'documentos_fiscais_alternativos',
          descricao: 'Documentos fiscais (Certificado MEI, Contrato Social, Requerimento de Empresário)*',
        },
        groupedAlternatives: documentosFiscaisAlt,
      });
    }

    return optionItems;
  };

  const listarDocumentosObrigatoriosPendentes = () => {
    const pendentes = [];

    const grupos = [
      { grupo: 'empresa', options: listaOptionsTiposDocumentoEmpresa },
      { grupo: 'comprovante', options: listaOptionsTiposDocumentoComprovantes },
      { grupo: 'socio', options: listaOptionsTiposDocumentoSocio },
      {
        grupo: 'conjuge',
        options:
          crud?.data?.pessoa?.pessoaFisica?.estadoCivil?.constante === 'CASADO' ||
            crud?.data?.pessoa?.pessoaFisica?.estadoCivil?.constante === 'UNIAO_ESTAVEL'
            ? listaOptionsTiposDocumentoConjuge
            : [],
      },
    ];

    grupos.forEach(({ grupo, options }) => {
      const optionItems = getOptionItemsComAlternativos(options);

      optionItems.forEach(({ docTipo, index, groupedAlternatives }) => {
        if (!isDocObrigatorio(docTipo, grupo, index)) return;

        const sourceItems =
          groupedAlternatives && groupedAlternatives.length > 0 ? groupedAlternatives : [{ docTipo, index }];

        const anexado = sourceItems.some(
          ({ docTipo: sourceDocTipo, index: sourceIndex }) => getDocFiles(grupo, sourceDocTipo, sourceIndex).length > 0,
        );
        if (anexado) return;

        pendentes.push({
          grupo: getLabelGrupoDocumento(grupo),
          documento: docTipo?.label,
        });
      });
    });

    return pendentes;
  };

  const buildDocumentoTipoElements = ({ grupo, optionItems = [], mappingData, onUploadAction }) => {
    ensureDocumentosPorTipo();

    const elements = {};

    optionItems.forEach(({ docTipo, index, groupedAlternatives }) => {
      const sourceItems =
        groupedAlternatives && groupedAlternatives.length > 0 ? groupedAlternatives : [{ docTipo, index }];
      const isGrouped = sourceItems.length > 1;
      const firstSource = sourceItems[0];
      const docId = getDocTipoId(docTipo, index);
      const field = getDocFieldPath(grupo, firstSource.docTipo, firstSource.index);
      const required = isDocObrigatorio(docTipo, grupo, index);
      const anexado = sourceItems.some(
        ({ docTipo: sourceDocTipo, index: sourceIndex }) => getDocFiles(grupo, sourceDocTipo, sourceIndex).length > 0,
      );

      let fileName = '';
      for (const sourceItem of sourceItems) {
        const sourceFileName = getNomeArquivoAnexado(grupo, sourceItem.docTipo, sourceItem.index);
        if (sourceFileName) {
          fileName = sourceFileName;
          break;
        }
      }

      const subselectOptions = isGrouped
        ? sourceItems.map((sourceItem) => ({
          id: getDocTipoId(sourceItem.docTipo, sourceItem.index),
          label: String(sourceItem.docTipo?.label || '')
            .replace(/\s*\*+\s*$/, '')
            .trim(),
        }))
        : [];

      const subselectFieldMap = isGrouped
        ? sourceItems.reduce((acc, sourceItem) => {
          const sourceDocId = getDocTipoId(sourceItem.docTipo, sourceItem.index);
          acc[sourceDocId] = getDocFieldPath(grupo, sourceItem.docTipo, sourceItem.index);
          return acc;
        }, {})
        : null;

      elements[`doc_${grupo}_${docId}`] = {
        type: 'card',
        styleClass: 'nomargin',
        disabled: !podeEditarDocumentos(),
        elements: {
          status_pendente: {
            type: 'span',
            rendered: !anexado,
            styleClass: 'file-field-name',
            customIcon: {
              icon: 'fas fa-times-circle text-danger fa-2x',
              style: { marginRight: '10px' },
            },
            value: docTipo?.label,
          },
          status_ok: {
            type: 'span',
            rendered: anexado,
            styleClass: 'file-field-name',
            customIcon: {
              icon: 'fas fa-check-circle text-success fa-2x',
              style: { marginRight: '10px' },
            },
            value: docTipo?.label,
          },
          arquivo_info: {
            type: 'span',
            rendered: anexado,
            styleClass: 'file-name',
            value: `📎 ${fileName}`,
          },
          arquivo: {
            type: 'file',
            icon: 'fa fa-upload',
            label: '',
            ...uploadCfg,
            upload: true,
            required,
            rendered: !anexado,
            disabled: !podeEditarDocumentos(),
            multiple: true,
            preview: false,
            filesLimit: 1,
            dialog: true,
            field,
            subselectOptions,
            subselectFieldMap,
            change: {
              action: onUploadAction,
            },
            mapping: {
              data: mappingData,
            },
            params: {
              tipoDocumento: docId,
              tipo: docId,
            },
          },
          remover_anexo: {
            type: 'button',
            rendered: anexado,
            disabled: !podeEditarDocumentos(),
            theme: 'secondary',
            styleClass: 'remove-file-btn',
            icon: 'fa fa-trash',
            click: {
              validate: false,
              action: () => {
                sourceItems.forEach((sourceItem) => {
                  const sourceField = getDocFieldPath(grupo, sourceItem.docTipo, sourceItem.index);
                  utils.set(sourceField, crud.data, []);
                  utils.set(sourceField, crud.changed, []);
                });
                crud.refresh();
                setCrud(crud);
                setIndex((prev) => prev + 1);
              },
            },
          },
        },
      };
    });

    return elements;
  };

  const buildDocumentosBlocos = ({ grupo, options = [], mappingData, onUploadAction }) => {
    const optionItems = getOptionItemsComAlternativos(options);

    const obrigatorios = optionItems.filter(({ docTipo, index }) => isDocObrigatorio(docTipo, grupo, index));
    const opcionais = optionItems.filter(({ docTipo, index }) => !isDocObrigatorio(docTipo, grupo, index));

    return {
      docs_obrigatorios: {
        styleClass: 'nomargin documentos_consultor',
        label: utils.lng('obrigatorios', 'Obrigatórios'),
        elements:
          obrigatorios.length > 0
            ? buildDocumentoTipoElements({
              grupo,
              optionItems: obrigatorios,
              mappingData,
              onUploadAction,
            })
            : {
              sem_docs_obrigatorios: {
                type: 'span',
                value: utils.lng('sem_documentos_obrigatorios', 'Sem documentos obrigatórios para este cadastro.'),
              },
            },
      },
      docs_opcionais: {
        styleClass: 'nomargin documentos_consultor',
        label: utils.lng('opcionais', 'Opcionais'),
        rendered: opcionais.length > 0,
        elements:
          opcionais.length > 0
            ? buildDocumentoTipoElements({
              grupo,
              optionItems: opcionais,
              mappingData,
              onUploadAction,
            })
            : {
              sem_docs_opcionais: {
                type: 'span',
                value: utils.lng('sem_documentos_opcionais', 'Sem documentos opcionais para este cadastro.'),
              },
            },
      },
    };
  };

  const prepararPayloadDocumentosPorTipo = () => {
    ensureDocumentosPorTipo();

    const documentos = {
      empresa: [],
      comprovantes: [],
      socios: [],
      conjuge: [],
    };

    const grupos = [
      {
        grupo: 'empresa',
        target: 'empresa',
        options: listaOptionsTiposDocumentoEmpresa,
        mappingData: 'caminho',
      },
      {
        grupo: 'comprovante',
        target: 'comprovantes',
        options: listaOptionsTiposDocumentoComprovantes,
        mappingData: 'caminho',
      },
      {
        grupo: 'socio',
        target: 'socios',
        options: listaOptionsTiposDocumentoSocio,
        mappingData: 'url',
      },
      {
        grupo: 'conjuge',
        target: 'conjuge',
        options: listaOptionsTiposDocumentoConjuge,
        mappingData: 'url',
      },
    ];

    grupos.forEach(({ grupo, target, options, mappingData }) => {
      toDocumentoArray(options).forEach((docTipo, index) => {
        const docId = getDocTipoId(docTipo, index);
        const field = getDocFieldPath(grupo, docTipo, index);
        const files = toDocumentoArray(getByPath(crud?.data, field));

        files.forEach((file) => {
          if (!file) return;

          const registro = { ...file };
          registro.tipoDocumento = docId;
          registro.tipo = docId;

          if (mappingData === 'caminho' && !registro.caminho && registro.data) {
            registro.caminho = registro.data;
          }

          if (mappingData === 'url' && !registro.url && registro.data) {
            registro.url = registro.data;
          }

          documentos[target].push(registro);
        });
      });
    });

    utils.set('documentos', crud.data, documentos);
    utils.set('documentos', crud.changed, documentos);
  };

  crud.salvarDocumentosConsultor = function () {
    if (isSalvando) {
      return;
    }

    if (!podeEditarDocumentos()) {
      crud.exibeAlerta(
        utils.lng(
          'documentos_bloqueados_etapa_anterior',
          'Para enviar documentos, conclua as etapas anteriores antes de salvar e continuar.',
        ),
      );
      return;
    }

    const docsObrigatoriosPendentes = listarDocumentosObrigatoriosPendentes();
    if (docsObrigatoriosPendentes.length > 0) {
      const listaPendencias = docsObrigatoriosPendentes
        .map((item) => `<li><b>${item.grupo}:</b> ${item.documento}</li>`)
        .join('');

      crud.exibeAlerta(
        `${utils.lng(
          'preencha_documentos_obrigatorios',
          'Existem documentos obrigatórios pendentes. Anexe os itens abaixo para continuar:',
        )}<ul>${listaPendencias}</ul>`,
      );
      return;
    }

    ensureDocumentosPorTipo();
    prepararPayloadDocumentosPorTipo();

    setIsSalvando(true);

    const request = {
      crud,
      changed: crud.changed,
      element: {},
      complete: () => setIsSalvando(false),
      onerror: () => setIsSalvando(false),
      cfg: {
        method: 'POST',
        url: 'salvarDocumentosConsultor/{id}',
        redirect: '/consultores/' + stage + '/evoluir',
      },
      validate: true,
      data: crud.data,
    };

    utils.call(request);
  };

  const internacional = user.codigo_pais !== 'BRA';
  const labelEvoluir = utils.lng('evoluir_para_di', 'Evoluir para D.I');
  const labelRecomendar = internacional ? labelEvoluir : utils.lng('recomendar', 'Recomendar');

  crud.data.internacional = internacional;

  const tabs_etapas = [
    { label: utils.lng('dados_cadastrais', 'Dados cadastrais'), key: 'dados' },
    { label: utils.lng('pontos', 'Pontos'), key: 'pontos', rendered: !internacional },
    { label: labelRecomendar, key: 'recomendar' },
    { label: utils.lng('documentos', 'Documentos'), key: 'documentos' },
    { label: labelEvoluir, key: 'evoluir', rendered: !internacional },
  ];

  const limpaContaAgencia = (texto) => {
    // Remove todos os hifens
    texto = texto.replace(/[^0-9A-Za-z-]/g, '').toUpperCase();

    if (texto.includes('-')) {
      texto = texto.replace(/(.*?)-(.*)/, (_, p1, p2) => p1 + '-' + p2.replace(/-/g, ''));
    }

    return texto;
  };

  const setAgenciaConta = (path, str, ...fields) => {
    if (str) {
      let split = str.split('-');

      for (const i in split) {
        const s = split[i];
        const f = fields[i];
        const field = `${path}.${f}`;

        utils.set(field, crud.data, s);
        utils.set(field, crud.changed, s);
      }
    }
  };

  const buildPayloadRecomendarSemMascara = (crudAtual) => {
    const dataAtual = crudAtual?.data || {};
    const cnpjAtual = dataAtual?.pessoa?.pessoaJuridica?.cnpj;

    if (cnpjAtual) {
      dataAtual.pessoa.pessoaJuridica.cnpj = utils.onlyNumber(cnpjAtual, false);
    }

    return dataAtual;
  };

  const isPermiteCadastrarCidade = function () {
    return paisCadastro && paisCadastro.codigo_pais === 'PRT' && utils.nvl(crud.changed?.filtroPais?.id, 0) > 0;
  };

  const labelContinuar = utils.lng('continuar', 'Continuar');
  const card_dados_bancarios = {
    type: 'card',
    rendered: internacional,
    disabled: '${crud.data.id > 0 && !("|Adm Cadastro|SuperAdmin|".indexOf(user.perfil.descricao) > -1 )}',
    label: utils.lng('dados_bancarios', 'Dados bancários'),
    elements: {
      banco: {
        field: 'pessoa.dadosBancarios.nomeBanco',
        label: utils.lng('banco', 'Banco'),
        type: 'text',
        required: true,
      },
      contaCompleta: {
        field: 'pessoa.dadosBancarios.conta_completa',
        label: utils.lng('banco_conta', 'Conta'),
        type: 'text',
        required: true,
        space: 4,
        replace: (str) => {
          return limpaContaAgencia(str);
        },
        change: {
          action: (args) => {
            setAgenciaConta('pessoa.dadosBancarios', args.query, 'conta', 'dvConta');
          },
        },
      },
      tipo: {
        space: 4,
        type: 'select',
        field: 'pessoa.dadosBancarios.tipo',
        itemLabel: 'label',
        itemValue: 'value',
        required: true,
        label: utils.lng('tipo_conta_banco', 'Tipo de cuenta'),
        data: [
          { label: utils.lng('conta_corrente', 'Corrente'), value: 'CORRENTE' },
          { label: utils.lng('conta_poupanca', 'Poupança'), value: 'POUPANCA' },
        ],
      },
      observacao: {
        field: 'pessoa.dadosBancarios.observacao',
        nome: 'pessoaDadosBancarios_observacao',
        label: utils.lng('observacoes_dados_bancarios', 'Observações'),
        rowEdit: true,
        rows: 2,
        style: { width: '100%' },
        type: 'textarea',
        required: false,
        translated: true,
        styleClass: 'ui-input-observacao',
      },
    },
  };

  const evoluir_right = {
    space: 6,
    elements: {
      isConsultorPessoaFisica: {
        field: 'isConsultorPessoaFisica',
        required: true,
        rendered: internacional && !user.codigo_pais.includes('PRT'),
        styleClass: 'checkbox_consultor_pf_pj',
        disabled: '${!crud.evolucao.permite_alterar_consultor}',
        label: utils.lng('tipo_consultor_di', 'Tipo de Registro'),
        trueLabel: utils.lng('pessoa_fisica', 'Persona Natural'),
        falseLabel: utils.lng('pessoa_juridica', 'Persona Moral'),
        nullValues: true,
        change: {
          update: ['dados_pessoa_juridica'],
        },
        type: 'checkbox',
        space: 12,
      },
      regimeFiscal: {
        field: 'dadosComerciais.regimeFiscal',
        type: 'select',
        translated: true,
        label: utils.lng('regime_fiscal', 'Regime Fiscal'),
        required: paisCadastro && paisCadastro.codigo_pais === 'MEX',
        rendered: paisCadastro && paisCadastro.codigo_pais === 'MEX',
        space: 12,
        list: {
          url: 'RegimeFiscal',
          send: false,
        },
      },
      dados_pessoa_juridica: {
        space: 12,
        rendered: '${!@this.isConsultorPessoaFisica}',
        elements: {
          dados_pessoa_consultor: {
            type: internacional ? 'card' : undefined,
            space: 12,
            elements: {
              nome: {
                field: 'pessoa.nome',
                type: 'text',
                label: utils.lng('razao_social', 'Razão Social'),
                required: true,
              },
              ddi: {
                field: 'pessoa.telefones.ddi',
                label: utils.lng('ddi', 'DDI'),
                mask: '999',
                type: 'ddi',
                required: false,
                space: 2,
                country: paisCadastro ? paisCadastro.codigo_pais : utils.getPaisUser(),
                change: {
                  update: ['ddd'],
                },
              },
              ddd: {
                field: 'pessoa.telefones.ddd',
                label: utils.lng('ddd', 'DDD'),
                mask: '99',
                maskKey: 'ddd_mask',
                maskCustom: paisCadastro?.ddd_mask,
                type: 'tel',
                required: true,
                space: 2,
                blur: {
                  url: 'isTelefoneJaCadastrado',
                  complete: 'trataValidacaoTelefone',
                  global: false,
                  requestWhen:
                    'crud.data.pessoa.telefones.ddd && crud.data.pessoa.telefones.telefone && crud.data.pessoa.telefones.telefone.length > 7',
                  send: {
                    telefone: '${@this.pessoa.telefones.ddd+""+@this.pessoa.telefones.telefone}',
                    pessoa: '${@this.pessoa.id}',
                    consultor: '${crud.data.id_consultor}',
                  },
                },
              },
              telefone: {
                field: 'pessoa.telefones.telefone',
                label: utils.lng('telefone_whats', 'Telefone (WhatsApp)'),
                mask: foneMask,
                type: 'tel',
                required: true,
                space: 4,
                blur: {
                  url: 'isTelefoneJaCadastrado',
                  global: false,
                  complete: 'trataValidacaoTelefone',
                  requestWhen:
                    'crud.data.pessoa.telefones.ddd && crud.data.pessoa.telefones.telefone && crud.data.pessoa.telefones.telefone.length > 7',
                  send: {
                    telefone: '${@this.pessoa.telefones.ddd+""+@this.pessoa.telefones.telefone}',
                    pessoa: '${@this.pessoa.id}',
                    consultor: '${crud.data.id_consultor}',
                  },
                },
              },
              email: {
                field: 'pessoa.emails.email',
                label: utils.lng('email', 'Email'),
                type: 'email',
                required: true,
                space: 6,
                blur: {
                  url: 'isEmailJaCadastrado',
                  complete: 'trataValidacaoEmail',
                  global: false,
                  send: {
                    email: '${@this.pessoa.emails.email}',
                    pessoa: '${@this.pessoa.id}',
                    consultor: '${crud.data.id_consultor}',
                  },
                },
              },
              cnpj: {
                field: 'pessoa.pessoaJuridica.cnpj',
                type: 'text',
                mask: cnpjMask,
                translated: true,
                label: utils.lng('cnpj', 'CNPJ'),
                required: true,
                space: 6,
                blur: {
                  url: 'isCnpjJaCadastrado',
                  complete: 'trataValidacaoCNPJ',
                  global: false,
                  send: {
                    cnpj: '${@this.pessoa.pessoaJuridica.cnpj}',
                    pessoa: '${@this.pessoa.id}',
                    cidade: '${@this.pessoa.enderecos.cidade.id}',
                  },
                },
              },
              inscricaoEstadual: {
                field: 'pessoa.pessoaJuridica.ie',
                type: 'text',
                translated: true,
                label: utils.lng('incricao_estadual', 'Inscrição Estadual'),
                required: "${user.codigo_pais === 'BRA'}",
                rendered: "${user.codigo_pais === 'BRA'}",
                space: 6,
              },
              /*
              regimeFiscal: {
                field: 'dadosComerciais.regimeFiscal',
                type: 'select',
                translated: true,
                label: utils.translateByPais( paisCadastro ? paisCadastro.id_pais : null, 'regime_fiscal', 'Regime Fiscal' ),
                required: paisCadastro && paisCadastro.codigo_pais === 'MEX',
                rendered: paisCadastro && paisCadastro.codigo_pais === 'MEX',
                space: 6,
                list: {
                  url: 'RegimeFiscal',
                  send: false,
                },
              },
              */
              agg_pais: {
                space: 12,
                elements: {
                  pais: {
                    field: 'filtroPais',
                    label: utils.lng('pais', 'Pais'),
                    entity: 'Pais',
                    add: false,
                    rendered: '${!crud.data.id > 0 && crud.data.internacional === true}',
                    list: { url: 'Pais?sortBy=descricao&sortType=asc' },
                    type: 'entity',
                    required: true,
                    space: 4,
                  },
                  cep: {
                    field: 'pessoa.enderecos.cep',
                    space: 8,
                    min: 8,
                    change: {
                      url: 'consultarCEP',
                      requestWhen: "crud.user.codigo_pais === 'BRA'",
                      target: 'pessoa.enderecos',
                      complete: 'setarCEP',
                      send: {
                        cep: '${@this.pessoa.enderecos.cep}',
                      },
                    },
                    label: utils.lng('cep_consult', 'CEP'),
                    type: 'text',
                    mask: cepMask,
                    required: paisCadastro ? paisCadastro.codigo_pais === 'BRA' : utils.getPaisUser() === 'BRA',
                  },
                },
              },
              logradouro: {
                field: 'pessoa.enderecos.logradouro',
                type: 'text',
                label: utils.lng('endereco', 'Endereço'),
                required: true,
              },
              numero: {
                field: 'pessoa.enderecos.numero',
                type: 'text',
                label: utils.lng('numero', 'Numero'),
                required: true,
                space: 4,
              },
              complemento: {
                field: 'pessoa.enderecos.complemento',
                type: 'text',
                label: utils.lng('complemento', 'Complemento'),
                space: 8,
                maxLength: 150,
              },
              bairro: {
                field: 'pessoa.enderecos.bairro',
                label: utils.lng('bairro', 'Bairro'),
                type: 'text',
                required: true,
                space: 12,
              },
              cidade: {
                field: 'pessoa.enderecos.cidade',
                value: '${@this.pessoa.enderecos.cidade.descricao}',
                label: utils.lng('cidade', 'Cidade'),
                entity: 'Cidade',
                add: false,
                list: {
                  url: 'listar_cidades_cadastro_consultor',
                  send: () => {
                    let id_pais = utils.nvl(crud.changed?.filtroPais?.id, getIdPaisAtual());
                    let send = { id_pais, exibir_busca: true };

                    return send;
                  },
                },
                type: 'entity',
                required: true,
                disabled: isCepValido,
                space: 9,
                blur: {
                  url: 'isCnpjJaCadastrado',
                  complete: 'trataValidacaoCNPJ',
                  requestWhen: 'typeof crud.data.pessoa.enderecos.cidade.id === "number"',
                  send: {
                    cnpj: '${@this.pessoa.pessoaJuridica.cnpj}',
                    pessoa: '${@this.pessoa.id}',
                    cidade: '${@this.pessoa.enderecos.cidade.id}',
                  },
                },
              },
              btn_nova_cidade: {
                type: 'button',
                variant: 'outlained',
                label: utils.lng('nao_encontrei_minha_cidade', 'Não encontrei minha cidade'),
                rendered: isPermiteCadastrarCidade,
                space: 3,
                click: {
                  action: 'switchDialogNovaCidade',
                },
              },
              avatar: {
                field: 'pessoa.avatar',
                upload: true,
                dialog: true,
                showLabel: false,
                type: 'upload',
                label: utils.lng('adicionar_foto_consultor', 'Adicionar foto do consultor'),
              },
            },
          },

          ver_entrevista: {
            type: 'link',
            value: utils.lng('ver_entrevista', 'Ver entrevista'),
            rendered: '${crud.evolucao.id_entrevista > 0}',
            href: "${'/ver_entrevista/' + crud.evolucao.id_entrevista}",
          },
        },
      },
      dados_bancarios: card_dados_bancarios,
      aceite_area: {
        space: 12,
        style: { marginTop: '40px' },

        elements: {
          aceite_carta: {
            field: 'aceito',
            label: utils.lng('aceite_termos', 'Aceite de termos'),
            disabled: false,
            type: 'checkbox',
            space: 6,
            required: true,
          },
          recomendar: {
            background: '#008000',
            type: 'button',
            rendered: !internacional,
            space: 4,
            disabled: '${!crud.evolucao.pontos_atingidos}',
            label: utils.lng('eu_recomendo', 'Eu recomendo'),
            click: {
              url: 'Cliente',
              method: 'POST',
              send: (crudAtual) => buildPayloadRecomendarSemMascara(crudAtual),
              redirect: true,
            },
          },
        },
      },
    },
  };

  const bloco_carta = {
    type: 'legend',
    label: utils.lng('carta_recomendacao_label_1', 'Carta de recomendação'),
    elements: {
      card_carta: {
        styleClass: 'nomargin',
        disabled:
          '${!crud.evolucao.permite_alterar_consultor || crud.recomendar !== true || !crud.evolucao.pontos_atingidos}',
        label: utils.lng('carta_recomendacao_label_2', 'Preencher carta de recomendação para o novo DI'),
        type: 'card',
        elements: {
          carta_left: {
            space: 6,
            style: { padding: '20px 5px' },
            elements: {
              recarea: { value: utils.lng('carta_recomendacao_label_3', 'Carta de recomendação'), type: 'span' },
            },
          },
          carta_right: evoluir_right,
        },
      },
    },
  };

  const bloco_evoluir = {
    type: 'legend',
    label: labelEvoluir,
    elements: {
      card_carta: {
        styleClass: 'nomargin',
        disabled:
          '${!crud.evolucao.permite_alterar_consultor || crud.recomendar !== true || !crud.evolucao.pontos_atingidos}',
        type: 'card',
        elements: {
          carta_left: {
            space: 6,
            style: { padding: '20px' },
            elements: {
              recarea: {
                value: utils.lng(
                  'carta_evoluir_internacional',
                  'Si su Consultor ya alcanzó la meta de puntuación, podrá continuar con su evolución a Distribuidor Independiente.',
                ),
                type: 'span',
              },
            },
          },
          carta_right: evoluir_right,
        },
      },
    },
  };

  const isDesativarEnderecoSemPais = () => {
    if (internacional) {
      let id_pais = utils.nvl(crud.changed?.filtroPais?.id, 0);

      return id_pais <= 0;
    }
    return !isCepValido;
  };

  let [openDlgKitHash, setOpenDlgKitHash] = useState(false);
  crud.switchDlgKitHash = function (isShow) {
    openDlgKitHash = typeof isShow === undefined ? !openDlgKitHash : isShow;
    setOpenDlgKitHash(openDlgKitHash);
    setIndex(index++);
  };

  crud.selecionaKitHash = function (_el, args) {
    if (crud && crud.data && crud.data.dadosComerciais) {
      crud.data.dadosComerciais.chaveKitHash = args.data?.hash;
    }
    crud.switchDlgKitHash();
  };

  const selecaoKitHash = {
    name: 'selecaoKitHash',
    type: 'list',
    dialog: true,
    onCloseDialog: function () {
      crud.switchDlgKitHash(false);
    },
    autoOpen: true,
    label: utils.lng('selecionar_hash', 'Selecionar Hash'),
    list: {
      url: 'endpoint.listar.pedidokithash',
      method: 'GET',
      send: {
        only_disponiveis: true,
        //query: '${@this.query}',
        //id_cliente: '${@this.id}'
      },
    },
    click: {
      action: 'selecionaKitHash',
    },
    columns: {
      pedido: { type: 'text', field: 'numero_pedido', label: utils.lng('n_pedido', 'Nº Pedido') },
      descricao_produto: { type: 'text', field: 'descricao_sku', label: utils.lng('produto', 'Produto') },
      data_inclusao_pedido: {
        type: 'date',
        field: 'data_inclusao_pedido',
        label: utils.lng('data_pedido', 'Data Pedido'),
      },
      hash: { type: 'text', field: 'hash', label: utils.lng('chave_hash', 'Chave Hash') },
    },
  };

  const consultor = {
    name: 'consultor',
    elements: {
      tabs: {
        type: 'list',
        layout: 'tab-menu',
        search: false,
        controls: false,
        itemVar: 'ti',
        rowStyleClass: '${ti.key === crud.data.tab ? "ui-tab-menu-sel" : ""}',
        header: false,
        columns: {
          label: { type: 'span', icon: 'fa fa-angle-right' },
        },
        click: {
          action: 'setarTab',
        },
        data: tabs_etapas,
      },
      content: {
        disabled: '${crud.data.editar === false}',
        elements: {
          regras: {
            type: 'list',
            search: false,
            header: false,
            widgetVar: 'wRegras',
            controls: false,
            rendered: "${crud.data.id > 0 && user.codigo_pais === 'BRA'}",
            list: {
              url: 'listarRegraAdesao',
              send: {
                id_consultor: '${crud.data.id_consultor}',
              },
            },
            rowStyleClass:
              "ui-fase ui-fase-class-ajust ui-fase-${@this.passou_individual && @this.passou_requeridos ? 'ok' : @this.atingiu_meta_parcialmente === true ? 'parcial' : 'err'}",
            columns: {
              fase: {
                type: 'include',
                src: '/templates/fase.html',
              },
            },
            space: 12,
          },
          // bt_ev_confirmar: {
          //   type: "button",
          //   space: 6,
          //   styleClass: "buttonEvoluir",
          //   disabled: "${!crud.evolucao.permite_alterar_consultor}",
          //   rendered:
          //     "${crud.permiteEvoluirEnergy !== undefined && crud.permiteEvoluirEnergy && @this.tipo.constante.indexOf('CONSULTOR') > -1 && !crud.evolucao.carta}",
          //   label: utils.lng("evoluir_como_di_energy", "Evoluir como DIEnergy"),
          //   click: {
          //     prompt: utils.lng("confirmar_evo_consultor_como_di_energy", "Confirmar evolução do consultor como DIEnergy?"),
          //     url: "Cliente/" + idConsultor,
          //     method: "PUT",
          //     send: {
          //       tipo: "CONSULTOR_ENERGY",
          //     },
          //     validate: false,
          //     redirect: true,
          //     reload: true,
          //   },
          // },
          no_permition: {
            rendered:
              "${crud.data.tab === 'documentos' && !crud.evolucao.permite_alterar_consultor && !user.administrativo}",
            elements: {
              empty: {
                style: {
                  textAlign: 'center',
                },
                type: 'card',
                elements: {
                  no_result: {
                    type: 'span',
                    label: utils.lng(
                      'sem_permissao_visualizar_doctos_consultor',
                      'Você não possui permissão para visualizar esses documentos, apenas o 1º D.I Ascendente',
                    ),
                  },
                },
              },
            },
          },
          tab_lista_documentos: {
            rendered: "${crud.data.tab === 'documentos' && crud.evolucao.documentos}",
            elements: {
              card_docs_empresa: {
                label: utils.lng('lista_documentos', 'Lista de documentos'),
                type: 'card',
                elements: {
                  lista_docs: {
                    type: 'list',
                    styleClass: 'lista-documentos-enviados',
                    widgetVar: 'wDocumentosEnviados',
                    list: {
                      url: 'listarDocumentosCliente?id_cliente=' + crud.distribuidor,
                      send: false,
                    },
                    header: false,
                    columns: {
                      tipo: {},
                      url: { type: 'link', click: { action: 'visualizarDocumentoEnviado', validate: false } },
                      editar: {
                        styleClass: 'ui-col-edit',
                        icon: 'fa fa-edit',
                        click: {
                          validate: false,
                          action: 'editarDocumentoEnviado',
                        },
                      },
                    },
                  },
                },
              },
              botoes: {
                style: { marginTop: '10px', marginBottom: '15px', marginRight: '11px' },
                elements: {
                  proximo: {
                    label:
                      utils.getPaisUser() === 'BRA' ? labelContinuar : utils.lng('salvar_fechar', 'Salvar e fechar'),
                    type: 'button',
                    style: { marginBottom: '5px' },
                    click:
                      utils.getPaisUser() === 'BRA'
                        ? {
                          action: 'openTab',
                          tab: 'evoluir',
                        }
                        : {
                          redirect: '/consultores',
                        },
                  },
                  voltar: {
                    label: utils.lng('voltar', 'Voltar'),
                    type: 'button',
                    style: { marginBottom: '5px' },
                    click: {
                      action: 'backTab',
                    },
                  },
                },
              },
            },
          },
          tab_documentos: {
            rendered:
              "${crud.evolucao.permite_alterar_consultor && crud.data.tab === 'documentos' && !crud.evolucao.documentos}",
            edit: '${true}',
            styleClass: 'tab_documentos',
            elements: {
              card_docs_empresa: {
                label: utils.lng('documentos_fiscais', 'Documentos fiscais'),
                type: 'card',
                disabled: listaTipoDoctosEmpresa == null || listaTipoDoctosEmpresa === '',
                elements: buildDocumentosBlocos({
                  grupo: 'empresa',
                  options: listaOptionsTiposDocumentoEmpresa,
                  mappingData: 'caminho',
                  onUploadAction: 'onUploadEmpresa',
                }),
              },
              card_docs_comprovante: {
                label: utils.lng('comprovantes', 'Comprovantes'),
                disabled: listaTipoDoctosComprovantes == null || listaTipoDoctosComprovantes === '',
                countries: '|BRA|',
                type: 'card',
                elements: buildDocumentosBlocos({
                  grupo: 'comprovante',
                  options: listaOptionsTiposDocumentoComprovantes,
                  mappingData: 'caminho',
                  onUploadAction: 'onUploadComprovante',
                }),
              },
              card_docs_socio: {
                label: utils.lng('documentos_pessoais', 'Documentos pessoais'),
                type: 'card',
                disabled: listaTipoDoctoSocio == null || listaTipoDoctoSocio === '',
                elements: buildDocumentosBlocos({
                  grupo: 'socio',
                  options: listaOptionsTiposDocumentoSocio,
                  mappingData: 'url',
                  onUploadAction: 'onUploadSocio',
                }),
              },
              card_docs_conjuge: {
                rendered:
                  crud?.data?.pessoa?.pessoaFisica?.estadoCivil?.constante === 'CASADO' ||
                  crud?.data?.pessoa?.pessoaFisica?.estadoCivil?.constante === 'UNIAO_ESTAVEL',
                label: utils.lng('documentos_conjuge', 'Documentos do cônjuge'),
                type: 'card',
                disabled: listaTipoDoctoConjuge == null || listaTipoDoctoConjuge === '',
                elements: buildDocumentosBlocos({
                  grupo: 'conjuge',
                  options: listaOptionsTiposDocumentoConjuge,
                  mappingData: 'url',
                  onUploadAction: 'onUploadConjuge',
                }),
              },
              botoes: {
                style: { marginTop: '15px' },
                elements: {
                  salvar: {
                    label: utils.lng('salvar_continuar', 'Salvar e continuar'),
                    type: 'button',
                    disabled: '${crud.isSalvando === true}',
                    icon: '${crud.isSalvando ? "fas fa-circle-notch fa-spin" : ""}',
                    click: {
                      validate: true,
                      action: 'salvarDocumentosConsultor',
                    },
                  },
                  voltar,
                },
              },
            },
          },
          dados: {
            rendered: "${crud.data.tab === 'dados'}",
            disabled: "${crud.data.id > 0 && crud.data.status && crud.data.status.constante !== 'ATIVO'}",
            label: utils.lng('cadastrar_consultor', 'Cadastrar consultor'),
            type: 'legend',
            elements: {
              // boco_aceite: {
              //   styleClass: 'nomargin',
              //   type: 'card',
              //   elements: {
              //     campos chaveKitHash - kitHash - loteArs estavam aqui
              //   }
              // },
              boco_left: {
                space: 6,
                elements: {
                  card_pais: {
                    type: 'card',
                    disabled: '${crud.data.id > 0}',
                    rendered: listaPaisesUsuario && listaPaisesUsuario.length > 1,
                    label: utils.lng('pais', 'País'),
                    styleClass: 'nomargin-left ui-card-pais-atual ui-click',
                    click: {
                      action: 'reiniciaCadastro',
                    },
                    elements: {
                      bandeira: {
                        value: paisCadastro ? paisCadastro.icone : '',
                        type: 'img',
                        space: 2,
                      },
                      pais_label: {
                        field: 'paisCadastro.nome_pais',
                        cols: 0,
                        label: paisCadastro
                          ? paisCadastro.nome_pais
                            ? paisCadastro.nome_pais
                            : paisCadastro.nome
                          : '',
                        type: 'span',
                      },
                      troca: {
                        cols: 0,
                        style: { marginLeft: 20 },
                        value: 'fa fa-search',
                        type: 'icon',
                      },
                    },
                  },
                  card_geracao: {
                    type: 'card',
                    disabled: '${crud.data.id > 0}',
                    styleClass: 'nomargin-left',
                    label: utils.lng('geracao_ascendente', 'Geração Ascendente'),
                    elements: {
                      g_grupo: {
                        elements: {
                          geracao_label: {
                            field: 'dadosComerciais.clientePaiEmpresarial.descricao',
                            rendered: '${crud.data.id > 0}',
                            cols: 12,
                            label: utils.lng('pai', 'Pai'),
                            type: 'text',
                            disabled: true,
                          },
                          geracao: {
                            cols: 12,
                            field: 'dadosComerciais.clientePaiEmpresarial',
                            rendered: '${!(crud.data.id > 0)}',
                            required: true,
                            label: utils.lng('selecionar_pai', 'Selecionar'),
                            type: 'entity',
                            entity: 'Cliente',
                            size: 20,
                            required: true,
                            dialog: true,
                            // columns: {
                            //   descricao: { label: utils.lng('nome','Nome')+'EEEEEEEE' }
                            // },
                            click: {
                              validate: false,
                              action: 'select',
                            },
                            // selector: true,
                            list: {
                              url:
                                'listarPaiMonitor' +
                                (paisCadastro
                                  ? paisCadastro.id_pais
                                    ? '?id_pais_cadastro=' + paisCadastro.id_pais
                                    : paisCadastro.id
                                      ? '?id_pais_cadastro=' + paisCadastro.id
                                      : ''
                                  : ''),
                            },
                          },
                        },
                      },
                      // tipo: {
                      //   field: 'tipo', label: 'Tipo', type: 'select', disabled: true, space: 6, data: [
                      //     { label: 'Consultor', value: 'CONSULTOR' }
                      //   ]
                      // },
                      data_admissao: {
                        field: 'dadosComerciais.dataRegistroPenn',
                        label: utils.lng('Data_de_admissao', 'Data de admissão'),
                        type: 'date',
                        required: true,
                        space: 12,
                      },
                    },
                  },
                  bloco_dados: {
                    disabled:
                      '${crud.data.id > 0 && !("|Adm Cadastro|SuperAdmin|".indexOf(user.perfil.descricao) > -1 )}',
                    elements: {
                      card_dados: {
                        type: 'card',
                        styleClass: 'nomargin-left',
                        label: utils.lng('Dados_pessoais', 'Dados pessoais'),
                        elements: {
                          nome: {
                            field: 'pessoa.nome',
                            label: utils.lng('nome', 'Nome'),
                            type: 'text',
                            required: true,
                            disabled:
                              '${!crud.evolucao.permite_alterar_consultor || crud.evolucao.is_consultor_evoluindo}',
                            maxLength: 100,
                          },
                          cpf: {
                            field: 'pessoa.pessoaFisica.cpf',
                            mask: cpfMask,
                            translated: true,
                            label: utils.lng('cpf', 'CPF'),
                            type: 'text',
                            required: true,
                            space: 6,
                            disabled:
                              '${!crud.evolucao.permite_alterar_consultor || crud.evolucao.is_consultor_evoluindo}',
                            change: { action: 'changeCpf' },
                          },
                          rg: {
                            field: 'pessoa.pessoaFisica.rg',
                            translated: true,
                            label: utils.lng('rg', 'RG'),
                            mask: rgMask,
                            maxLength: rgMask ? rgMask.length : 18,
                            type: 'text',
                            //numeric: true,
                            required: true,
                            space: 6,
                            disabled:
                              '${!crud.evolucao.permite_alterar_consultor || crud.evolucao.is_consultor_evoluindo}',
                          },
                          nascimento: {
                            field: 'pessoa.pessoaFisica.dataNascimento',
                            label: utils.lng('data_nascimento', 'Data de nascimento'),
                            type: 'date',
                            required: true,
                            space: 6,
                            disabled:
                              '${!crud.evolucao.permite_alterar_consultor || crud.evolucao.is_consultor_evoluindo}',
                          },
                          estadoCivil: {
                            disabled:
                              '${!crud.evolucao.permite_alterar_consultor || crud.evolucao.is_consultor_evoluindo || @this.id > 0}',
                            field: 'pessoa.pessoaFisica.estadoCivil',
                            label: utils.lng('estado_civil', 'Estado civil'),
                            type: 'select',
                            required: true,
                            space: 6,
                            list: {
                              url: 'EstadoCivil',
                              send: false,
                            },
                          },
                          ddi: {
                            field: 'pessoa.telefones.ddi',
                            label: utils.lng('ddi', 'DDI'),
                            mask: '999',
                            type: 'ddi',
                            country: paisCadastro ? paisCadastro.codigo_pais : utils.getPaisUser(),
                            change: {
                              update: ['ddd'],
                            },
                            required: false,
                            space: 3,
                            disabled:
                              '${!crud.evolucao.permite_alterar_consultor || crud.evolucao.is_consultor_evoluindo}',
                          },
                          ddd: {
                            field: 'pessoa.telefones.ddd',
                            label: utils.lng('ddd', 'DDD'),
                            mask: '99',
                            maskKey: 'ddd_mask',
                            maskCustom: paisCadastro?.ddd_mask,
                            type: 'tel',
                            required: true,
                            space: 2,
                            disabled:
                              '${!crud.evolucao.permite_alterar_consultor || crud.evolucao.is_consultor_evoluindo}',
                          },
                          telefone: {
                            field: 'pessoa.telefones.telefone',
                            label: utils.lng('telefone_whats)', 'Telefone (WhatsApp)'),
                            mask: '99999-99999',
                            type: 'tel',
                            required: true,
                            space: 4,
                            disabled:
                              '${!crud.evolucao.permite_alterar_consultor || crud.evolucao.is_consultor_evoluindo}',
                          },
                          email: {
                            field: 'pessoa.emails.email',
                            label: utils.lng('email', 'Email'),
                            type: 'email',
                            required: true,
                            space: 6,
                            disabled:
                              '${!crud.evolucao.permite_alterar_consultor || crud.evolucao.is_consultor_evoluindo}',
                            blur: {
                              url: 'isEmailJaCadastrado',
                              complete: 'trataValidacaoEmail',
                              global: false,
                              send: {
                                email: '${@this.pessoa.emails.email}',
                                pessoa: '${@this.pessoa.id}',
                                consultor: '${crud.data.id_consultor}',
                              },
                            },
                            maxLength: 60,
                          },
                          filial: {
                            disabled: '${!crud.evolucao.permite_alterar_consultor || crud.evolucao.carta === true}',
                            field: 'filial',
                            label: utils.lng('filial_vinculo', 'Filial de Vínculo'),
                            type: 'entity',
                            entity: 'Filial',
                            required: true,
                            space: 6,
                            list: {
                              url: 'Filial?id_pais_cadastro=' + getIdPaisAtual(),
                            },
                          },
                          confirmaAutencidadeEmail: {
                            field: 'dadosComerciais.confirmaAutencidadeEmail',
                            required: true,
                            rendered: internacional,
                            disabled: '${!crud.evolucao.permite_alterar_consultor}',
                            labelPlacement: 'end',
                            label: utils.lng(
                              'pergunta_confirma_email_valido',
                              'Declaro estar al tanto de la necesidad de proporcionar un correo electrónico válido para la firma digital del contrato de distribución y para recibir las comunicaciones oficiales de Nipponflex.',
                            ),
                            type: 'checkbox',
                            space: 12,
                          },
                          participouMmn: {
                            field: 'dadosComerciais.participouMmn',
                            required: true,
                            nullValues: true,
                            label: utils.lng(
                              'participou_mmn_pergunta',
                              'Já participou de outras marcas do ramo de colchoaria?',
                            ),
                            type: 'checkbox',
                            space: 12,
                            // disabled: '${!crud.evolucao.permite_alterar_consultor || crud.evolucao.carta === true}',
                            change: {
                              action: 'changeParticipaMmn',
                            },
                          },
                          outraMarca: {
                            field: 'dadosComerciais.outraMarca',
                            label: utils.lng('qual_marca', 'Qual a marca?'),
                            type: 'text',
                            space: 12,
                            rendered: '${@this.dadosComerciais.participouMmn == true}',
                            required: true,
                            // disabled: '${!crud.evolucao.permite_alterar_consultor || crud.evolucao.carta === true}',
                          },
                          possuiParentesco: {
                            label: utils.lng(
                              'possui_parentesco',
                              'Possui parentesco com outro administrador qualificado?',
                            ),
                            type: 'checkbox',
                            space: 12,
                            field: 'dadosComerciais.possuiParentesco',
                            nullValues: true,
                            required: true,
                            disabled: '${!crud.evolucao.permite_alterar_consultor || crud.evolucao.carta === true}',
                          },
                          grauParentesco: {
                            field: 'dadosComerciais.grauParentesco',
                            label: utils.lng('grau_de_parentesco', 'Grau de parentesco'),
                            type: 'select',
                            space: 6,
                            rendered: '${@this.dadosComerciais.possuiParentesco == true}',
                            required: true,
                            disabled: '${!crud.evolucao.permite_alterar_consultor ||  crud.evolucao.carta === true}',
                            data: [
                              { label: utils.lng('pai', 'Pai'), value: 'Pai' },
                              { label: utils.lng('mae', 'Mãe'), value: 'Mãe' },
                              { label: utils.lng('tio_tia', 'Tio(a)'), value: 'Tio(a)' },
                              { label: utils.lng('avo_seletor', 'Avô(ó)'), value: 'Avô(ó)' },
                              { label: utils.lng('filho_seletor', 'Filho(a)'), value: 'Filho(a)' },
                              { label: utils.lng('irmao_seletor', 'Irmão(ã)'), value: 'Irmão(ã)' },
                              { label: utils.lng('sogro_seletor', 'Sogro(a)'), value: 'Sogro(a)' },
                              { label: utils.lng('primo_seletor', 'Primo(a)'), value: 'Primo(a)' },
                              { label: utils.lng('enteado_seletor', 'Enteado(a)'), value: 'Enteado(a)' },
                              { label: utils.lng('cunhado_seletor', 'Cunhado(a)'), value: 'Cunhado(a)' },
                              { label: utils.lng('sobrinho_seletor', 'Sobrinho(a)'), value: 'Sobrinho(a)' },
                            ],
                          },
                          nomeParentesco: {
                            field: 'dadosComerciais.nomeParentesco',
                            label: utils.lng('qual_nome_parente', 'Qual o nome?'),
                            type: 'text',
                            space: 6,
                            rendered: '${@this.dadosComerciais.possuiParentesco == true}',
                            required: true,
                            disabled: '${!crud.evolucao.permite_alterar_consultor || crud.evolucao.carta === true}',
                          },
                        },
                      },
                      card_conjuge: {
                        rendered:
                          "${@this.pessoa.pessoaFisica.estadoCivil.constante === 'CASADO' || @this.pessoa.pessoaFisica.estadoCivil.constante === 'UNIAO_ESTAVEL'}",
                        type: 'card',
                        styleClass: 'nomargin-left',
                        label: utils.lng('Dados_conjuge', 'Dados Cônjuge'),
                        elements: {
                          cpfConjuge: {
                            disabled:
                              '${!crud.evolucao.permite_alterar_consultor || crud.evolucao.is_consultor_evoluindo}',
                            field: 'pessoa.pessoaFisica.cpfConjuge',
                            mask: cpfMask,
                            required:
                              "${@this.pessoa.pessoaFisica.estadoCivil.constante === 'CASADO' || @this.pessoa.pessoaFisica.estadoCivil.constante === 'UNIAO_ESTAVEL'}",
                            translated: true,
                            label: utils.lng('CPF Cônjuge', 'CPF cônjuge'),
                            type: 'text',
                            required: true,
                            space: 6,
                            list: {
                              url: 'EstadoCivil',
                              send: false,
                            },
                          },
                          nomeConjuge: {
                            disabled:
                              '${!crud.evolucao.permite_alterar_consultor || crud.evolucao.is_consultor_evoluindo}',
                            field: 'pessoa.pessoaFisica.nomeConjuge',
                            rendered:
                              "${@this.pessoa.pessoaFisica.estadoCivil.constante === 'CASADO' || @this.pessoa.pessoaFisica.estadoCivil.constante === 'UNIAO_ESTAVEL'}",
                            required:
                              "${@this.pessoa.pessoaFisica.estadoCivil.constante === 'CASADO' || @this.pessoa.pessoaFisica.estadoCivil.constante === 'UNIAO_ESTAVEL'}",
                            label: utils.lng('nome_conjuge', 'Nome cônjuge'),
                            type: 'text',
                            required: true,
                            space: 6,
                          },
                          ddiConjuge: {
                            field: 'pessoa.pessoaFisica.ddiConjuge',
                            label: utils.lng('ddi', 'DDI'),
                            mask: '999',
                            type: 'ddi',
                            rendered: internacional,
                            country: paisCadastro ? paisCadastro.codigo_pais : utils.getPaisUser(),
                            change: {
                              update: ['ddd'],
                            },
                            required: false,
                            space: 3,
                            disabled:
                              '${!crud.evolucao.permite_alterar_consultor || crud.evolucao.is_consultor_evoluindo}',
                          },
                          telefoneConjuge: {
                            disabled:
                              '${!crud.evolucao.permite_alterar_consultor || crud.evolucao.is_consultor_evoluindo}',
                            field: 'pessoa.pessoaFisica.telefoneConjuge',
                            rendered: internacional,
                            label: utils.lng('telefone_conjuge', 'Telefone Cônjuge'),
                            type: 'text',
                            required: true,
                            space: 6,
                            mask: foneMask,
                            type: 'tel',
                          },
                          dataNascimentoConjuge: {
                            disabled:
                              '${!crud.evolucao.permite_alterar_consultor || crud.evolucao.is_consultor_evoluindo}',
                            field: 'pessoa.pessoaFisica.dataNascimentoConjuge',
                            required: true,
                            label: utils.lng('data_nascimento_conjuge', 'Data de Nascimento do Cônjuge'),
                            type: 'date',
                            required: true,
                            space: 6,
                          },
                        },
                      },
                    },
                  },
                },
              },
              boco_right: {
                space: 6,
                styleClass: 'nomargin',
                type: 'card',
                elements: {
                  chaveKitHash: {
                    field: 'dadosComerciais.chaveKitHash',
                    // elRequired: "${user.codigo_pais === 'BRA' && !exists(@this,'dadosComerciais.chaveKitHash') && !exists(@this,'dadosComerciais.loteArs') && !equals(@this,'dadosComerciais.participouMmn', true)}",
                    // elRequired: "${ user.codigo_pais === 'BRA' && ( ( requerKitHash === true ) || ( requerKitHashOuARS === true && !exists( @this,'dadosComerciais.loteArs' ) ) ) && !equals( @this,'dadosComerciais.participouMmn', true ) }",
                    // elRequired: "${ user.codigo_pais === 'BRA' && ( ( requerKitHash === true ) || ( requerKitHashOuARS === true && (!crud.data.dadosComerciais || !crud.data.dadosComerciais.loteArs) ) ) && crud.data.dadosComerciais.participouMmn !== true } " ,
                    required: isKitHashObrigatorio,
                    rendered: user.codigo_pais === 'BRA',
                    label: utils.lng(
                      'cod_ativacao_chave_kit_hash',
                      'Cód. de Ativação: ARA (todos), KBE (todos), Alcaline Power ou 2 Travesseiros',
                    ),
                    edit: '${!(crud.data.id > 0)}',
                    disabled: "${equals(@this,'dadosComerciais.participouMmn', true)}",
                    type: 'text',
                    maxLength: 5,
                    space: 9,
                    change: {
                      action: 'refreshObrigatoriedadeKitHashLoteARS',
                    },
                  },
                  selecaoKitHash: {
                    type: 'button',
                    label: utils.lng('selecionar_cod_ativacao', 'Selecionar cod. de ativação'),
                    edit: '${!(crud.data.id > 0)}',
                    disabled: "${equals(@this,'dadosComerciais.participouMmn', true)}",
                    rendered: user.codigo_pais === 'BRA',
                    theme: 'primary',
                    space: 3,
                    click: {
                      validate: false,
                      action: 'switchDlgKitHash',
                    },
                  },
                  ou: {
                    label: utils.lng('ou', 'OU'),
                    rendered:
                      (user.codigo_pais === 'BRA' && user.perfil.descricao === 'Distribuidor Independente (D.I)') ||
                      user.perfil.descricao === 'Diretoria' ||
                      user.perfil.descricao === 'Atendente Filial' ||
                      user.perfil.descricao === 'Adm Cadastro',
                    styleClass: 'ui-bold ui-big ui-center',
                    type: 'label',
                  },
                  kitHash: {
                    field: 'dadosComerciais.kitHash',
                    label: utils.lng('codigo_ativacao', 'Código de ativação'),
                    required: false,
                    rendered: false,
                    edit: '${!(crud.data.id > 0)}',
                    type: 'select',
                    itemValue: 'id_hash',
                    itemLabel: 'codigo',
                    maxLength: 5,
                    list: {
                      url: 'listarKitHash',
                      send: {
                        id_consultor: '${crud.data.id}',
                      },
                    },
                  },
                  loteArs: {
                    field: 'dadosComerciais.loteArs',
                    label: utils.lng('lote_ars', 'Lote: ARS'),
                    disabled:
                      "${(crud.evolucao && !crud.evolucao.permite_alterar_consultor) || equals(@this,'dadosComerciais.participouMmn', true)}",
                    rendered:
                      (user.codigo_pais === 'BRA' && user.perfil.descricao === 'Distribuidor Independente (D.I)') ||
                      user.perfil.descricao === 'Diretoria' ||
                      user.perfil.descricao === 'Atendente Filial' ||
                      user.perfil.descricao === 'Adm Cadastro',
                    // elRequired: "${ user.codigo_pais === 'BRA' && ( ( requerARS === true ) || ( requerKitHashOuARS === true && !exists( @this,'dadosComerciais.chaveKitHash' ) ) ) && !equals( @this,'dadosComerciais.participouMmn', true ) }",
                    // elRequired: "${ user.codigo_pais === 'BRA' && ( ( requerARS === true ) || ( requerKitHashOuARS === true && (!crud.data.dadosComerciais || !crud.data.dadosComerciais.chaveKitHash) ) ) && crud.data.dadosComerciais.participouMmn !== true }",
                    required: isLoteArsObrigatorio,
                    type: 'text',
                    maxLength: 9,
                    change: {
                      action: 'refreshObrigatoriedadeKitHashLoteARS',
                    },
                  },
                  card_endereco: {
                    type: 'card',
                    label: utils.lng('endereco', 'Endereço'),
                    styleClass: 'nomargin-right',
                    disabled:
                      '${crud.data.id > 0 && !("|Adm Cadastro|SuperAdmin|".indexOf(user.perfil.descricao) > -1 )}',
                    elements: {
                      cep: {
                        field: 'pessoa.enderecos.cep',
                        min: 8,
                        space: 3,
                        disabled: '${!crud.evolucao.permite_alterar_consultor || crud.evolucao.is_consultor_evoluindo}',
                        blur: {
                          action: 'blurCep',
                        },
                        change: {
                          requestWhen: "crud.user.codigo_pais === 'BRA'",
                          url: 'consultarCEP',
                          complete: 'setarCEP',
                          target: 'pessoa.enderecos',
                          send: {
                            cep: '${@this.pessoa.enderecos.cep}',
                          },
                        },
                        translated: true,
                        label: utils.lng('cep_consult', 'CEP'),
                        //label: utils.translateByPais((paisCadastro ? paisCadastro.id_pais : null), "cep_consult", "CEP"),
                        type: 'text',
                        mask: cepMask,
                        required: paisCadastro ? paisCadastro.codigo_pais === 'BRA' : utils.getPaisUser() === 'BRA',
                        maxLength: 10,
                      },
                      pais: {
                        field: 'filtroPais',
                        label: utils.lng('pais', 'Pais'),
                        entity: 'Pais',
                        add: false,
                        change: {
                          update: ['end_detalhe', 'cidade'],
                        },
                        rendered: '${!crud.data.id > 0 && crud.data.internacional === true}',
                        list: { url: 'Pais?sortBy=descricao&sortType=asc' },
                        type: 'entity',
                        required: true,
                        space: 12,
                      },
                      cidade: {
                        field: 'pessoa.enderecos.cidade',
                        value: '${@this.pessoa.enderecos.cidade.descricao}',
                        label: utils.lng('cidade', 'Cidade'),
                        entity: 'Cidade',
                        disabled: isDesativarEnderecoSemPais,
                        add: false,
                        list: {
                          url: 'listar_cidades_cadastro_consultor',
                          send: () => {
                            let id_pais = utils.nvl(crud.changed?.filtroPais?.id, getIdPaisAtual());
                            let send = { id_pais, exibir_busca: true };

                            return send;
                          },
                        },
                        type: 'entity',
                        required: true,
                        space: 9,
                      },
                      btn_nova_cidade: {
                        type: 'button',
                        variant: 'outlained',
                        label: utils.lng('nao_encontrei_minha_cidade', 'Não encontrei minha cidade'),
                        rendered: isPermiteCadastrarCidade,
                        space: 3,
                        click: {
                          action: 'switchDialogNovaCidade',
                        },
                      },
                      end_detalhe: {
                        space: 12,
                        disabled: isDesativarEnderecoSemPais,
                        elements: {
                          logradouro: {
                            field: 'pessoa.enderecos.logradouro',
                            label: utils.lng('logradouro', 'Logradouro'),
                            type: 'text',
                            required: true,
                            space: 12,
                            disabled:
                              '${!crud.evolucao.permite_alterar_consultor || crud.evolucao.is_consultor_evoluindo}',
                            maxLength: 120,
                          },
                          numero: {
                            field: 'pessoa.enderecos.numero',
                            label: utils.lng('numero', 'Número'),
                            type: 'text',
                            required: true,
                            space: 4,
                            disabled:
                              '${!crud.evolucao.permite_alterar_consultor || crud.evolucao.is_consultor_evoluindo}',
                            maxLength: 7,
                          },
                          complemento: {
                            field: 'pessoa.enderecos.complemento',
                            label: utils.lng('complemento', 'Complemento'),
                            type: 'text',
                            space: 8,
                            disabled:
                              '${!crud.evolucao.permite_alterar_consultor || crud.evolucao.is_consultor_evoluindo}',
                          },
                          bairro: {
                            field: 'pessoa.enderecos.bairro',
                            label: utils.lng('bairro', 'Bairro'),
                            type: 'text',
                            required: true,
                            space: 12,
                            disabled:
                              '${!crud.evolucao.permite_alterar_consultor || crud.evolucao.is_consultor_evoluindo}',
                            maxLength: 60,
                          },
                        },
                      },
                    },
                  },
                },
              },
              aceite_consultor: {
                disabled: '${!crud.evolucao.permite_alterar_consultor || crud.evolucao.is_consultor_evoluindo}',
                label: utils.lng(
                  'aceite_carta_in',
                  'Declaro serem verdadeiras e assumo total resposabilidade pelas informações aqui prestadas.',
                ),
                required: true,
                type: 'checkbox',
              },
              botoes: {
                style: { marginTop: '15px' },
                styleClass: 'botoes_salvar_consultor_recomendar',
                elements: {
                  salvar: {
                    label: utils.lng('salvar_continuar', 'Salvar e continuar'),
                    disabled: '${crud.isSalvando == true}',
                    type: 'button',
                    rendered: '${@this.id <= 0}',
                    icon: '${crud.isSalvando == true ? "fa fa-spinner fa-spin" : ""}',
                    click: {
                      action: 'salvarCliente',
                    },
                  },
                  atualizar: {
                    disabled: '${!crud.evolucao.permite_alterar_consultor}',
                    rendered: '${@this.id > 0}',
                    label: utils.lng('salvar_continuar', 'Salvar e continuar'),
                    type: 'button',
                    click: {
                      method: 'PUT',
                      url: 'Cliente/{id}',
                      complete: 'afterSaveCliente',
                      params: {
                        status: crud.data.status,
                      },
                    },
                  },
                  voltar,
                },
              },
            },
          },
          pontos: {
            rendered: "${crud.data.tab === 'pontos' && user.codigo_pais === 'BRA'}",
            type: 'conteiner',
            elements: {
              bloco_pontos: {
                type: 'legend',
                label: utils.lng('cadastrar_pontos', 'Cadastrar pontos'),
                elements: {
                  produtos: {
                    label: utils.lng('produtos_comprado_consultor', 'Produtos comprados pelo consultor'),
                    type: 'list',
                    disabled: '${crud.evolucao.is_consultor_evoluindo && !crud.evolucao.evoluir_di_energy}',
                    // edit: "${!crud.evolucao.carta || (crud.evolucao.carta && !crud.evolucao.pontos) || (crud.evolucao.id_entrevista === 0 && crud.evolucao.entrevista)}",
                    edit: '${!crud.evolucao.carta || (crud.evolucao.carta && !crud.evolucao.pontos)}',
                    widgetVar: 'wProdutos',
                    add: {
                      action: 'openDialogEscolha',
                    },
                    columns: {
                      avatar: { type: 'avatar' },
                      codigo_produto: { label: utils.lng('codigo', 'Código') },
                      numero: { label: utils.lng('pedido', 'Pedido') },
                      descricao: { label: utils.lng('descricao', 'Descrição') },
                      quantidade: {
                        label: utils.lng('quantidade', 'Quantidade'),
                        type: 'number',
                        style: { width: '100px' },
                      },
                      pontos: {
                        aggregate: 'sum',
                        field: 'pontos',
                        format: 'number',
                        decimalCount: 4,
                        label: utils.lng('pontos', 'Pontos'),
                        filter: false,
                        sort: false,
                      },
                      editar: {
                        styleClass: 'ui-col-edit',
                        icon: 'fa fa-edit',
                        rendered: '${crud.evolucao.carta === false}',
                        disabled: '${@this.bloquear_remocao_ponto === true}',
                        click: {
                          action: 'editarItem',
                        },
                      },
                      remove: {
                        styleClass: 'ui-col-del',
                        icon: 'fa fa-trash',
                        rendered: '${crud.evolucao.carta === false}',
                        disabled: '${@this.bloquear_remocao_ponto === true}',
                        click: {
                          url: 'VendaVinculo/{id_vinculo}',
                          redirect: true,
                          method: 'DELETE',
                          prompt: utils.lng('deseja_remove_item', 'Deseja realmente remover o item?'),
                        },
                      },
                    },
                    list: {
                      url: 'listarItensPontosConsultor',
                      send: {
                        id_consultor: '${crud.data.id}',
                      },
                    },
                  },
                },
              },
              botoes: {
                style: { marginTop: '15px' },
                elements: {
                  salvar: {
                    label: labelContinuar,
                    type: 'button',
                    disabled: '${!crud.evolucao.pontos || crud.evolucao.is_consultor_evoluindo }',
                    click: {
                      action: 'openTab',
                      validate: true,
                      tab: 'recomendar',
                    },
                  },
                  voltar: {
                    label: utils.lng('voltar', 'Voltar'),
                    type: 'button',
                    click: {
                      action: 'backTab',
                    },
                  },
                },
              },
            },
          },
          recomendar: {
            rendered: "${crud.data.tab === 'recomendar'}",
            type: 'conteiner',
            elements: {
              bloco_carta: internacional ? bloco_evoluir : bloco_carta,
              bloco_entrevista: {
                type: 'legend',
                label: utils.lng('entrevistar_consultor', 'Entrevistar consultor'),
                // desabilita enquanto não tiver os pontos
                // id_entrevista: usado para mostrar o botão Ver Entrevista
                // permite_alterar_consultor: apenas o 1º DI Ascendente
                // enviar_entrevista: usado para quando um Consulto Energy evolui (não precisa de entrevista) e depois ele quer evoluir em Consultor Nipponflex (precisa entrevista)
                // se passar o período de realização da entrevista, ela será considerada como feita (entrevista=true)
                rendered:
                  '${crud.evolucao.permite_alterar_consultor && crud.evolucao.carta && crud.evolucao.enviar_entrevista && crud.evolucao.pontos_atingidos === true && crud.evolucao.entrevista === false}',
                elements: {
                  card_entrevista: {
                    styleClass: 'nomargin ui-inline-child',
                    type: 'card',
                    elements: {
                      entrevistador: {
                        type: 'list',
                        required: true,
                        size: 1,
                        dialog: true,
                        search: false,
                        controls: false,
                        label: utils.lng('enviar_para_entrevistador', 'Enviar para entrevistador'),
                        actions: [
                          { action: 'close', label: utils.lng('cancelar', 'Cancelar') },
                          {
                            url: 'solicitarEntrevista',
                            method: 'POST',
                            label: utils.lng('enviar_para_entrevistador', 'Enviar para entrevistador'),
                            send: {
                              id_entrevistador: '${@this.id_cliente}',
                              id_consultor: '${crud.data.id_consultor}',
                            },
                          },
                        ],
                        columns: {
                          avatar: {},
                          nome: { label: utils.lng('empresa', 'Empresa') },
                          socio: { label: utils.lng('administrador_qualificado', 'Administrador Qualificado') },
                          graduacao: { label: utils.lng('graduacao', 'Graduação') },
                          select: {
                            icon: '${@this.atual ? "fa fa-check" : "fa fa-circle-o"}',
                          },
                        },
                        list: {
                          url: 'listarEntrevistadores?consultor={id_consultor}&size=1',
                          send: false,
                        },
                      },
                    },
                  },
                },
              },
              botoes: {
                style: { marginTop: '15px', marginBottom: '15px' },
                styleClass: 'botoes_salvar_consultor_recomendar',
                elements: {
                  salvar_nacional_area: {
                    rendered: '${!@this.internacional || @this.id > 0}',
                    elements: {
                      salvar: {
                        label: labelContinuar,
                        type: 'button',
                        disabledOnInvalid: true,
                        disabled:
                          '${!crud.evolucao.permite_alterar_consultor || !crud.evolucao.pontos_atingidos || crud.evolucao.is_consultor_evoluindo}',
                        click: {
                          action: 'openTab',
                          validate: true,
                          tab: 'documentos',
                        },
                      },
                    },
                  },
                  salvar_internacional_area: {
                    rendered: '${@this.internacional && !(@this.id > 0)}',
                    elements: {
                      salvar_internacional_pj: {
                        label: labelContinuar,
                        type: 'button',
                        rendered: '${!@this.isConsultorPessoaFisica}',
                        disabledOnInvalid: true,
                        disabled:
                          '${!crud.evolucao.permite_alterar_consultor || !crud.evolucao.pontos_atingidos || crud.evolucao.is_consultor_evoluindo}',
                        click: {
                          url: 'Cliente',
                          method: 'POST',
                          redirect: '/consultores/' + stage + '/documentos',
                        },
                      },
                      salvar_internacional_pf: {
                        label: labelContinuar,
                        type: 'button',
                        rendered: '${@this.isConsultorPessoaFisica === true}',
                        disabledOnInvalid: true,
                        disabled:
                          '${!crud.evolucao.permite_alterar_consultor || !crud.evolucao.pontos_atingidos || crud.evolucao.is_consultor_evoluindo}',
                        click: {
                          url: 'Cliente',
                          method: 'POST',
                          send: (crud) => {
                            let id_pessoa_consultor = crud.data.id_pessoa_consultor;
                            let socio = {
                              pessoa: id_pessoa_consultor,
                              socio: id_pessoa_consultor,
                              qualificado: true,
                              tipoSocio: 'SOCIO_ADMINISTRADOR',
                            };
                            let pessoa = { id: id_pessoa_consultor, socios: [socio] };
                            let cliente = {
                              id: 0,
                              pessoa,
                              tipo: 'DI',
                              status: 'RECOMENDACAO',
                              dadosComerciais: {
                                consultor: stage,
                                statusPenn: 'RECOMENDACAO',
                                regimeFiscal: crud.data?.dadosComerciais?.regimeFiscal,
                              },
                            };

                            pessoa.dadosBancarios = crud.changed?.pessoa?.dadosBancarios;

                            return cliente;
                          },
                          redirect: '/consultores/' + stage + '/documentos',
                        },
                      },
                    },
                  },
                  voltar: {
                    label: utils.lng('voltar', 'Voltar'),
                    type: 'button',
                    click: {
                      action: 'backTab',
                    },
                  },
                },
              },
            },
          },
          evoluir: {
            rendered: "${crud.data.tab === 'evoluir'}",
            type: 'conteiner',
            elements: {
              fases: {
                type: 'list',
                layout: 'card-row',
                header: false,
                search: false,
                rowStyle: { color: "${crud.evolucao[@this.key] ? 'green' : '#D20400' }" },
                columns: {
                  grupo: {
                    layout: 'grid',
                    elements: {
                      descricao: { field: 'descricao' },
                      icone: {
                        field: 'icone',
                        style: { textAlign: 'right' },
                        icon: "${crud.evolucao[@this.key] ? 'fa fa-check' : 'fa fa-times' }",
                      },
                    },
                  },
                },
                data: [
                  { descricao: utils.lng('dados_cadastrais', 'Dados cadastrais preechidos'), key: 'dados' },
                  { descricao: utils.lng('pontos_atingidos', 'Pontos atingidos'), key: 'pontos_atingidos' },
                  { descricao: utils.lng('carta_recomendacao', 'Carta de recomendação'), key: 'carta' },
                  { descricao: utils.lng('formulario_entrevista', 'Formulário de entrevista'), key: 'entrevista' },
                  { descricao: utils.lng('documentos', 'Documentos'), key: 'documentos' },
                ],
              },
              botoes: {
                style: { marginTop: '15px' },
                disabled: '${!access.EVOLUIR_DI && !user.administrativo}',
                elements: {
                  evoluir_para_di_nippon: {
                    label: utils.lng('evoluir_para_di_nippon', 'Evoluir para D.I. NipponFlex'),
                    type: 'button',
                    disabled:
                      '${!crud.evolucao.permite_alterar_consultor || (crud.evolucao.dados === false || crud.evolucao.carta === false || crud.evolucao.entrevista === false || crud.evolucao.documentos === false || crud.evolucao.pontos === false) || crud.data.editar === false}',
                    rendered: '${crud.evolucao.evoluir_di_energy === true}',
                    click: {
                      prompt: utils.lng('consultor_nipponflex', 'Esse consultor evoluíra para D.I. NipponFlex'),
                      url: 'cliente/{id_consultor}/evoluirDINipponFlex',
                      method: 'POST',
                      redirect: true,
                      reload: true,
                    },
                  },
                  // Ao completar a fase 1 um consultor pode virar DI energy
                  salvar: {
                    disabled: '${!access.EVOLUIR_DI && !user.administrativo}',
                    label: utils.lng('enviar_confirmacao_para_di', 'Enviar confirmação para cadastrar D.I'),
                    type: 'button',
                    disabled:
                      '${(crud.evolucao.dados === false || crud.evolucao.carta === false || crud.evolucao.entrevista === false || crud.evolucao.documentos === false || crud.evolucao.pontos_atingidos === false) || crud.data.editar === false}',
                    rendered: '${crud.evolucao.evoluir_di_energy === false && !crud.evolucao.is_consultor_evoluindo}',
                    click: {
                      method: 'PUT',
                      url: 'Cliente/' + distribuidor,
                      redirect: '/consultores',
                      prompt:
                        '|CONSULTOR_ENERGY|'.indexOf('|' + crud.data.tipo + '|') > -1
                          ? utils.lng('consultor_evoluira_dienergy', 'Esse consultor evoluírá para D.I. Energy')
                          : utils.lng(
                            'consultor_evoluira_dinipponflex',
                            'Esse consultor evoluírá para D.I. NipponFlex',
                          ),
                      send: {
                        status:
                          '|CONSULTOR_ENERGY|'.indexOf('|' + crud.data.tipo + '|') > -1
                            ? 'EVOLUIR_PARA_DIENERGY'
                            : 'EVOLUIR_PARA_DI',
                        tipo: 'DI',
                        dadosComerciais: {
                          statusPenn: 'RECOMENDACAO',
                        },
                      },
                    },
                  },
                  voltar: {
                    label: utils.lng('voltar', 'Voltar'),
                    type: 'button',
                    click: {
                      redirect: '/consultores/' + stage + '/documentos',
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  };

  crud.open = function (_el, args) {
    const d = args.data;
    const t = {};

    t.label = d.nome;
    t.key = 'consultor_' + d.id;
    t.view = '/consultores/' + d.id;
    t.path = '/consultores/' + d.id;

    utils.open(t);
  };

  crud.doUploadDocs = function (res) {
    const _ks_ = {};
    const _dt_ = {};

    _dt_.pessoa = {};
    _dt_.pessoa.documentos = crud.data.pessoa.documentos;

    _ks_.crud = crud;
    _ks_.changed = _dt_;
    _ks_.element = {};

    _ks_.cfg = {
      url: 'Cliente/' + crud.data.id,
      method: 'PUT',
    };
    utils.call(_ks_);
  };

  crud.afterSaveCliente = function (res) {
    if (!res.error) {
      const d = res.data;

      if (d && d.id) {
        window.location.href = '/consultores/' + d.id + '/' + (internacional ? 'recomendar' : 'pontos');
      }
    }
  };

  crud.openTab = function (el, args) {
    const cfg = el.click;

    localStorage.setItem('lastTab', cfg.tab);

    window.location.href = '/consultores/' + stage + '/' + cfg.tab;
  };

  crud.backTab = function (el, args) {
    let last = localStorage.getItem('lastTab');

    if (last) {
      let ok = false;

      for (let i = 0; i < tabs_etapas.length; i++) {
        const t = tabs_etapas[i];

        if (t.key === last) {
          let l = tabs_etapas[i - 1];

          if (l) {
            window.location.href = '/consultores/' + stage + '/' + l.key;
            localStorage.setItem('lastTab', l.key);
            ok = true;
            break;
          }
        }
      }
      if (!ok) {
        window.location.href = '/consultores';
        localStorage.removeItem('lastTab');
      }
    } else {
      window.history.back();
    }
  };

  crud.blurCep = function (el, args) {
    if (!el.query || el.query === '' || el.query == null) {
      crud.setarCEP({});
    }
  };

  const refreshListaDocumentosEnviados = function () {
    if (window.wDocumentosEnviados) {
      window.wDocumentosEnviados.search();
      return;
    }

    crud.refresh();
    setCrud(crud);
    setIndex((prev) => prev + 1);
  };

  const getDocumentoEndpoint = function (documento) {
    if (!documento || !documento.id) return null;

    const origemTabela = documento.origem_tabela;
    if (!origemTabela) return null;

    return `${encodeURIComponent(origemTabela)}/${encodeURIComponent(documento.id)}`;
  };

  const getDocumentoBase64 = function (file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = function () {
        const base64 = reader.result;
        const extensao = file.name && file.name.includes('.') ? file.name.split('.').pop() : '';

        resolve({
          base64,
          nome: file.name,
          extensao,
          tamanho_bytes: file.size,
        });
      };

      reader.onerror = function () {
        reject(new Error('Falha ao converter arquivo para base64.'));
      };

      reader.readAsDataURL(file);
    });
  };

  crud.visualizarDocumentoEnviado = function (_el, args) {
    const documento = args?.data ? args.data : {};
    const urlDocumento = utils.nvl(documento.url, documento.caminho, null);

    if (!urlDocumento) {
      crud.exibeAlerta(
        utils.lng(
          'erro_visualizar_documento_sem_url',
          'Não foi possível visualizar o documento porque o link não foi retornado na listagem.',
        ),
      );
      return;
    }

    window.open(urlDocumento, '_blank', 'noopener,noreferrer');
  };

  crud.editarDocumentoEnviado = function (_el, args) {
    const documento = args?.data ? args.data : {};
    const endpoint = getDocumentoEndpoint(documento);

    if (!endpoint) {
      crud.exibeAlerta(
        utils.lng(
          'erro_editar_documento_sem_identificador',
          'Não foi possível editar o documento porque o identificador não foi retornado na listagem.',
        ),
      );
      return;
    }

    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.pdf,.png,.jpg,.jpeg,.webp';

    input.onchange = async function (event) {
      const file = event?.target?.files?.[0];

      if (!file) return;

      try {
        const arquivo = await getDocumentoBase64(file);

        const payload =
          documento.origem_tabela === 'Documento'
            ? {
              id: documento.id,
              caminho: arquivo.base64,
              extensao: String(arquivo.extensao || '').toLowerCase(),
              nome: arquivo.nome,
              tamanho_bytes: Number(arquivo.tamanho_bytes || 0),
            }
            : {
              id: documento.id,
              url: arquivo.base64,
            };

        const request = {
          crud,
          changed: payload,
          element: {},
          cfg: {
            url: endpoint,
            method: 'PUT',
          },
          complete: function (res) {
            if (!res.error) {
              refreshListaDocumentosEnviados();
            }
          },
        };

        utils.call(request);
      } catch (error) {
        crud.exibeAlerta(
          `${utils.lng(
            'erro_base64_arquivo_edicao_documento',
            'Não foi possível processar o arquivo para edição do documento. Tente novamente.',
          )}\n\n${error?.message ? error.message : error}`,
        );
      }
    };

    input.click();
  };

  //CADASTRAR CIDDADE (EUROPA)
  const switchDialogNovaCidade = function () {
    openDialogNovaCidade = !openDialogNovaCidade;
    setOpenDialogNovaCidade(openDialogNovaCidade);
  };
  crud.switchDialogNovaCidade = switchDialogNovaCidade;

  const frmNovaCidade = {
    name: 'frmNovaCidade',
    elements: {
      pais: { type: 'entity', label: utils.lng('pais', 'País'), field: 'filtroPais', disabled: true, space: 12 },
      nome_cidade: { type: 'text', label: utils.lng('nome_cidade', 'Nome Cidade'), disabled: false, space: 12 },
      botoes: {
        type: 'span',
        style: {
          marginTop: '10px',
          marginBottom: '15px',
          marginRight: '11px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        },
        space: 12,
        elements: {
          fechar: {
            label: utils.lng('fechar', 'Fechar'),
            type: 'button',
            variant: 'contained',
            theme: 'secondary',
            style: { marginRight: '20px' },
            click: {
              action: 'switchDialogNovaCidade',
            },
          },
          confirmar: {
            disabled: '${!@this.nome_cidade}',
            label: utils.lng('confirmar', 'Confirmar'),
            variant: 'contained',
            theme: 'primary',
            type: 'button',
            click: {
              action: 'cadastraNovaCIdade',
            },
          },
        },
      },
    },
  };

  const cadastraNovaCIdade = function (_el, args) {
    if (args.data.filtroPais && args.data.filtroPais.id > 0 && args.data.nome_cidade && args.data.nome_cidade !== '') {
      const _ks_ = {};

      _ks_.crud = {};
      _ks_.changed = {};
      _ks_.element = {};
      _ks_.validate = false;

      _ks_.complete = function (res) {
        if (res.data && res.data.id > 0) {
          crud.data.pessoa.enderecos.cidade = res.data;
          crud.changed.pessoa.enderecos.cidade = crud.data.pessoa.enderecos.cidade;
        }
        switchDialogNovaCidade();
      };

      _ks_.cfg = {
        url: 'consultor/cidade/cadastrar?id_pais=' + args.data.filtroPais.id + '&nome_cidade=' + args.data.nome_cidade,
        method: 'POST',
      };
      utils.call(_ks_);
    }
  };
  crud.cadastraNovaCIdade = cadastraNovaCIdade;

  window.crud = crud;

  return (
    <View name="cliente-consultor" view={view}>
      <div className="ui-consultor">
        {stage !== 'list' && <Element value={consultor} crud={crud} data={crud.data} view={view}></Element>}
        {stage === 'list' && <Element value={consultores} crud={crud} data={crud.data} view={view}></Element>}
        {openDlgKitHash && (
          <Element id={'prdss-' + index} crud={crud} view={view} value={selecaoKitHash} data={crud.data}></Element>
        )}

        <Dialog
          open={showDlgSelecaoPais}
          className="ui-dlg-escolha-filial"
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="customized-dialog-title" onClose={crud.switchShowDlgSelecaoPais}>
            <span style={{ float: 'left' }}>
              {utils.lng('titulo_escolha_pais_consultor', 'Em qual país você deseja cadastrar este consultor?')}
            </span>
          </DialogTitle>
          <DialogContent>
            <Element disabled={false} value={dlgSelecaoPais} crud={crud} data={crudItem.data} view={view}></Element>
          </DialogContent>
          <DialogActions>
            <Button id="btnFecharPais" onClick={crud.switchShowDlgSelecaoPais} variant="outlined" color="secondary">
              {utils.lng('fechar', 'Fechar')}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog maxWidth="lg" onClose={handleCloseDialog} aria-labelledby="customized-dialog-title" open={openDialog}>
          <DialogTitle id="customized-dialog-title" onClose={handleCloseDialog}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
              <span style={{ float: 'left' }}>{utils.lng('add_produtos', 'Adicionar produtos')}</span>
              <span style={{ float: 'right' }}>
                {utils.lng('pontos', 'Pontos') + ': ' + somaPontosProdutosSelecionados}
              </span>
            </div>
          </DialogTitle>
          <DialogContent>
            <Element value={escolhaProdutos} crud={crud} data={crud.data} view={view} readOnly={false}></Element>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleCloseDialog} color="primary">
              {utils.lng('fechar', 'FECHAR').toUpperCase()}
            </Button>
            <Button
              autoFocus
              onClick={confirmaVinculacaoProdutos}
              color="primary"
              style={{ backgroundColor: '#0a4c96', color: '#fff' }}
            >
              {utils.lng('vincular_produtos', 'VINCULAR PRODUTOS').toUpperCase()}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          maxWidth="lg"
          onClose={handleCloseDialogItem}
          aria-labelledby="customized-dialog-title"
          open={openDialogItem}
        >
          <DialogTitle id="customized-dialog-title" onClose={handleCloseDialogItem}>
            {utils.lng('editar_item', 'Editar item')}
          </DialogTitle>
          <DialogContent>
            <Element value={frmEditItem} crud={crudItem} data={crudItem.data} view={view}></Element>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialogItem} color="primary">
              {utils.lng('fechar', 'FECHAR')}
            </Button>
            <Button autoFocus onClick={confirmarEdicaoItem} color="primary">
              {utils.lng('confirmar', 'CONFIRMAR').toUpperCase()}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog maxWidth="lg" aria-labelledby="customized-dialog-title" open={openDialogNovaCidade}>
          <DialogTitle id="customized-dialog-title" onClose={handleCloseDialogItem}>
            {utils.lng('cadastrar_nova_cidade', 'Cadastrar Nova Cidade')}
          </DialogTitle>
          <DialogContent>
            <Element value={frmNovaCidade} crud={crud} data={crud.data} view={view}></Element>
          </DialogContent>
        </Dialog>
      </div>
    </View>
  );
}

export default Consultor;
